import React, { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/AminiiCheckout.css";
import { refreshAccessToken } from "../Utils/authHelpers";
import { API_BASE_URL } from "../config/constants";
import { getGuestCart, clearGuestCart } from "../Utils/guestCart";

// ─── All 36 Indian States & Union Territories (clean names only, for State dropdown) ───
const INDIAN_STATES_LIST = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];

// ─── Major cities per state (for City dropdown) ───
// ─── Exhaustive list of actual cities per state / UT (for City dropdown) ───
const CITIES_BY_STATE = {
  "Andaman and Nicobar Islands": [
    "Bambooflat", "Car Nicobar", "Diglipur", "Garacharma", "Mayabunder", "Port Blair", "Rangat"
  ],
  "Andhra Pradesh": [
    "Adoni", "Amalapuram", "Amaravati", "Anakapalle", "Anantapur", "Bapatla", "Bhimavaram",
    "Chilakaluripet", "Chirala", "Chittoor", "Dharmavaram", "Eluru", "Gudivada", "Guntakal",
    "Guntur", "Hindupur", "Kadapa", "Kakinada", "Kavali", "Kurnool", "Machilipatnam",
    "Madanapalle", "Mangalagiri", "Markapur", "Nandyal", "Narasaraopet", "Nellore", "Ongole",
    "Palakollu", "Ponnur", "Proddatur", "Rajahmundry", "Rayachoti", "Samalkot", "Sattenapalle",
    "Srikakulam", "Srikalahasti", "Tadepalligudem", "Tadipatri", "Tenali", "Tirupati",
    "Vijayawada", "Vinukonda", "Visakhapatnam", "Vizianagaram", "Yemmiganur"
  ],
  "Arunachal Pradesh": [
    "Aalo (Along)", "Bomdila", "Changlang", "Daporijo", "Hawai", "Itanagar", "Jairampur",
    "Khonsa", "Naharlagun", "Namsai", "Pasighat", "Roing", "Seppa", "Tawang", "Tezu",
    "Yingkiong", "Ziro"
  ],
  "Assam": [
    "Barpeta", "Barpeta Road", "Biswanath Chariali", "Bongaigaon", "Dhekiajuli", "Dhubri",
    "Dibrugarh", "Digboi", "Diphu", "Dispur", "Duliajan", "Goalpara", "Golaghat", "Guwahati",
    "Haflong", "Hailakandi", "Hojai", "Jorhat", "Karimganj", "Kokrajhar", "Lakhimpur",
    "Lumding", "Mangaldai", "Morigaon", "Nagaon", "Nalbari", "North Lakhimpur", "Rangia",
    "Sibsagar", "Silchar", "Tezpur", "Tinsukia"
  ],
  "Bihar": [
    "Araria", "Arrah", "Aurangabad", "Bagaha", "Begusarai", "Bettiah", "Bhagalpur",
    "Bihar Sharif", "Buxar", "Chhapra", "Darbhanga", "Dehri", "Dumraon", "Forbesganj",
    "Gaya", "Gopalganj", "Hajipur", "Jamalpur", "Jamui", "Jehanabad", "Katihar",
    "Kishanganj", "Lakhisarai", "Madhubani", "Mokama", "Motihari", "Munger",
    "Muzaffarpur", "Nawada", "Patna", "Purnia", "Raxaul", "Saharsa", "Samastipur",
    "Sasaram", "Sitamarhi", "Siwan", "Supaul"
  ],
  "Chandigarh": [
    "Chandigarh"
  ],
  "Chhattisgarh": [
    "Ambikapur", "Bhilai", "Bilaspur", "Champa", "Charoda", "Dhamtari", "Durg",
    "Jagdalpur", "Janjgir", "Kanker", "Kawardha", "Kirandul", "Korba", "Mahasamund",
    "Manendragarh", "Mungeli", "Raigarh", "Raipur", "Rajnandgaon", "Ratanpur", "Sakti",
    "Tilda Newra"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Amli", "Daman", "Diu", "Silvassa"
  ],
  "Delhi": [
    "Central Delhi", "Connaught Place", "Delhi", "Dwarka", "East Delhi", "Karol Bagh",
    "Lajpat Nagar", "Mayur Vihar", "New Delhi", "North Delhi", "North East Delhi",
    "North West Delhi", "Pitampura", "Rohini", "Saket", "Shahdara", "South Delhi",
    "South East Delhi", "South West Delhi", "Vasant Kunj", "West Delhi"
  ],
  "Goa": [
    "Aldona", "Bicholim", "Calangute", "Canacona", "Cuncolim", "Curchorem", "Mapusa",
    "Margao", "Mormugao", "Panaji", "Pernem", "Ponda", "Quepem", "Sanguem", "Sanquelim",
    "Valpoi", "Vasco da Gama"
  ],
  "Gujarat": [
    "Ahmedabad", "Amreli", "Anand", "Anjar", "Ankleshwar", "Bardoli", "Bharuch",
    "Bhavnagar", "Bhuj", "Bilimora", "Botad", "Chandkheda", "Chhota Udaipur", "Dahod",
    "Deesa", "Dhoraji", "Gandhidham", "Gandhinagar", "Godhra", "Gondal", "Himmatnagar",
    "Jamnagar", "Jetpur", "Junagadh", "Kadi", "Kalol", "Keshod", "Khambhat", "Kheda",
    "Lunawada", "Mahesana", "Modasa", "Morbi", "Nadiad", "Navsari", "Palanpur", "Patan",
    "Petlad", "Porbandar", "Rajkot", "Sanand", "Savarkundla", "Sidhpur", "Surat",
    "Surendranagar", "Una", "Unjha", "Upleta", "Vadodara", "Valsad", "Vapi", "Veraval",
    "Viramgam", "Visnagar", "Wadhwan"
  ],
  "Haryana": [
    "Ambala", "Ambala Cantt", "Assandh", "Bahadurgarh", "Barwala", "Bhiwani", "Charkhi Dadri",
    "Cheeka", "Dharuhera", "Ellenabad", "Faridabad", "Fatehabad", "Gharaunda", "Gohana",
    "Gurugram", "Hansi", "Hisar", "Hodal", "Jhajjar", "Jind", "Kaithal", "Kalka", "Karnal",
    "Kurukshetra", "Ladwa", "Mandi Dabwali", "Narnaul", "Narwana", "Palwal", "Panchkula",
    "Panipat", "Pehowa", "Rania", "Rewari", "Rohtak", "Safidon", "Samalkha", "Shahbad",
    "Sirsa", "Sohna", "Sonipat", "Taraori", "Thanesar", "Tohana", "Yamunanagar"
  ],
  "Himachal Pradesh": [
    "Baddi", "Bilaspur", "Chamba", "Dalhousie", "Dharamshala", "Hamirpur", "Jawalamukhi",
    "Jogindernagar", "Kangra", "Kasauli", "Kullu", "Manali", "Mandi", "Nahan", "Nalagarh",
    "Nurpur", "Palampur", "Paonta Sahib", "Parwanoo", "Rampur", "Rohru", "Shimla",
    "Solan", "Sundernagar", "Una"
  ],
  "Jammu and Kashmir": [
    "Akhnoor", "Anantnag", "Bandipora", "Baramulla", "Batote", "Bhaderwah", "Bijbehara",
    "Budgam", "Doda", "Ganderbal", "Jammu", "Kathua", "Katra", "Kishtwar", "Kulgam",
    "Kupwara", "Pampore", "Poonch", "Pulwama", "Rajouri", "Ramban", "Ramnagar", "Reasi",
    "Samba", "Shopian", "Sopore", "Srinagar", "Tral", "Udhampur", "Uri"
  ],
  "Jharkhand": [
    "Adityapur", "Barkakana", "Bokaro Steel City", "Chaibasa", "Chakradharpur", "Chatra",
    "Deoghar", "Dhanbad", "Dumka", "Ghatshila", "Giridih", "Godda", "Gumla", "Hazaribagh",
    "Jamshedpur", "Jharia", "Jhumri Telaiya", "Katras", "Khunti", "Koderma", "Latehar",
    "Lohardaga", "Madhupur", "Medininagar (Daltonganj)", "Mihijam", "Pakur", "Phusro",
    "Ramgarh", "Ranchi", "Sahibganj", "Saraikela", "Saunda", "Simdega"
  ],
  "Karnataka": [
    "Arsikere", "Athani", "Bagalkote", "Ballari", "Belagavi", "Bengaluru", "Bhadravati",
    "Bidar", "Chamarajanagar", "Channapatna", "Chikodi", "Chikkaballapur", "Chikkamagaluru",
    "Chintamani", "Chitradurga", "Dandeli", "Davangere", "Dharwad", "Gadag-Betageri",
    "Gokak", "Guledgudda", "Harihar", "Hassan", "Haveri", "Honavar", "Hosapete",
    "Hubballi", "Ilkal", "Jamkhandi", "Kadur", "Kanakarayanahalli", "Karwar", "Kolar",
    "Kollegal", "Koppal", "Kumta", "Kundapura", "Madikeri", "Malavalli", "Mandya",
    "Mangaluru", "Mudhol", "Mysuru", "Nanjangud", "Nipani", "Puttur", "Rabkavi Banhatti",
    "Raichur", "Ramanagara", "Ranebennuru", "Ranibennur", "Robertsonpet (KGF)", "Sagara",
    "Sandur", "Sedam", "Shahabad", "Shahpur", "Shiggaon", "Shivamogga", "Shorapur",
    "Sidlaghatta", "Sindhanur", "Sira", "Sirsi", "Siruguppa", "Srinivaspur", "Talikota",
    "Tarikere", "Tiptur", "Tumakuru", "Udupi", "Vijayapura", "Wadi", "Yadgir"
  ],
  "Kerala": [
    "Alappuzha", "Aluva", "Angamaly", "Aroor", "Attingal", "Chalakudy", "Changanassery",
    "Cherthala", "Chittur-Thathamangalam", "Guruvayur", "Irinjalakuda", "Kalamassery",
    "Kanhangad", "Kannur", "Kasaragod", "Kayamkulam", "Kochi", "Kodungallur", "Kollam",
    "Kothamangalam", "Kottayam", "Kozhikode", "Kunnamkulam", "Malappuram", "Manjeri",
    "Maradu", "Mavelikkara", "Muvattupuzha", "Nedumangad", "Neyyattinkara", "Nilambur",
    "North Paravur", "Ottapalam", "Pala", "Palakkad", "Panniyannur", "Payyanur",
    "Perinthalmanna", "Perumbavoor", "Ponnani", "Punalur", "Shornur", "Taliparamba",
    "Thalassery", "Thiruvalla", "Thiruvananthapuram", "Thodupuzha", "Thrissur", "Tirur",
    "Tripunithura", "Vadakara", "Vaikom", "Varkala"
  ],
  "Ladakh": [
    "Alchi", "Diskit", "Drass", "Hunder", "Kargil", "Khalatse", "Leh", "Nubra",
    "Nyoma", "Padum", "Shey", "Tangtse", "Zanskar"
  ],
  "Lakshadweep": [
    "Agatti", "Amini", "Andrott", "Bitra", "Chethlath", "Kadmat", "Kalpeni",
    "Kavaratti", "Kiltan", "Minicoy"
  ],
  "Madhya Pradesh": [
    "Agar", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani", "Betul",
    "Bhind", "Bhopal", "Biaora", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh",
    "Datia", "Dewas", "Dhar", "Dindori", "Ganjbasoda", "Guna", "Gwalior", "Harda",
    "Hoshangabad (Narmadapuram)", "Indore", "Itarsi", "Jabalpur", "Jaora", "Jhabua",
    "Khandwa", "Khargone", "Khurai", "Kotma", "Maihar", "Mandideep", "Mandla",
    "Mandsaur", "Mauganj", "Morena", "Multai", "Murwara (Katni)", "Nagda", "Narsinghpur",
    "Neemuch", "Niwari", "Panna", "Pipariya", "Pithampur", "Raisen", "Rajgarh",
    "Ratlam", "Rewa", "Sagar", "Sanawad", "Sarangpur", "Satna", "Sehore", "Sendhwa",
    "Seoni", "Shahdol", "Shajapur", "Sheopur", "Shivpuri", "Shujalpur", "Sidhi",
    "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha"
  ],
  "Maharashtra": [
    "Achalpur", "Ahmednagar", "Airoli", "Akola", "Akot", "Alibag", "Amalner",
    "Ambarnath", "Amravati", "Anjangaon", "Aurangabad (Chhatrapati Sambhajinagar)",
    "Badlapur", "Ballarpur", "Baramati", "Barsi", "Bhadravati", "Bhandara",
    "Bhiwandi", "Bhusawal", "Bid", "Boisar", "Buldhana", "Chalisgaon", "Chandrapur",
    "Chiplun", "Chopda", "Dahanu", "Deolali", "Dhule", "Digras", "Dombivli",
    "Gadchiroli", "Gondia", "Hinganghat", "Hingoli", "Ichalkaranji", "Jalgaon",
    "Jalna", "Kalyan", "Kamthi", "Karad", "Karanja", "Khamgaon", "Khopoli",
    "Kolhapur", "Kopargaon", "Latur", "Lonavala", "Mahad", "Malegaon", "Malkapur",
    "Manmad", "Mira-Bhayandar", "Miraj", "Mumbai", "Murtizapur", "Nagpur", "Nanded",
    "Nandurbar", "Nashik", "Navi Mumbai", "Osmanabad (Dharashiv)", "Palghar",
    "Pandharpur", "Panvel", "Parbhani", "Phaltan", "Pimpri-Chinchwad", "Pune",
    "Pusad", "Ratnagiri", "Sangamner", "Sangli", "Satara", "Sawantwadi", "Shahada",
    "Shegaon", "Shirdi", "Shirpur", "Shrirampur", "Solapur", "Talegaon Dabhade",
    "Thane", "Ulhasnagar", "Uran", "Vasai-Virar", "Wardha", "Warora", "Washim", "Yavatmal"
  ],
  "Manipur": [
    "Bishnupur", "Chandel", "Churachandpur", "Imphal", "Jiribam", "Kakching",
    "Kamjong", "Kangpokpi", "Kwakeithel", "Lilong", "Mayang Imphal", "Moirang",
    "Moreh", "Nambol", "Noney", "Pallel", "Pherzawl", "Senapati", "Tamenglong",
    "Tengnoupal", "Thoubal", "Ukhrul", "Wangoi", "Yairipok"
  ],
  "Meghalaya": [
    "Baghmara", "Cherrapunji (Sohra)", "Jowai", "Mairang", "Mawkyrwat", "Nongpoh",
    "Nongstoin", "Resubelpara", "Shillong", "Tura", "Williamnagar"
  ],
  "Mizoram": [
    "Aizawl", "Champhai", "Hnahthial", "Khawzawl", "Kolasib", "Lawngtlai",
    "Lunglei", "Mamit", "Saitual", "Serchhip", "Siaha"
  ],
  "Nagaland": [
    "Chumukedima", "Dimapur", "Kiphire", "Kohima", "Longleng", "Mokokchung",
    "Mon", "Niuland", "Noklak", "Peren", "Phek", "Shamator", "Tminyu",
    "Tuensang", "Wokha", "Zunheboto"
  ],
  "Odisha": [
    "Anandapur", "Angul", "Asika", "Balangir", "Baleshwar (Balasore)", "Barbil",
    "Bargarh", "Baripada", "Belpahar", "Bhadrak", "Bhawanipatna", "Bhubaneswar",
    "Biramitrapur", "Brahmapur (Berhampur)", "Brajrajnagar", "Byasanagar", "Chhatrapur",
    "Cuttack", "Debagarh", "Dhenkanal", "Gunupur", "Hinjilicut", "Jagatsinghpur",
    "Jajpur", "Jatani", "Jeypore", "Jharsuguda", "Kendrapara", "Kendujhar (Keonjhar)",
    "Khordha", "Koraput", "Malkangiri", "Nabarangpur", "Nayagarh", "Nuapada",
    "Paradip", "Paralakhemundi", "Phulbani", "Puri", "Rairangpur", "Rajgangpur",
    "Rayagada", "Rourkela", "Sambalpur", "Subarnapur (Sonepur)", "Sunabeda",
    "Talcher", "Titlagarh", "Vyasanagar"
  ],
  "Puducherry": [
    "Karaikal", "Kurumbapet", "Madagadipet", "Mahe", "Ozhukarai", "Puducherry",
    "Villianur", "Yanam"
  ],
  "Punjab": [
    "Abohar", "Ahmedgarh", "Amritsar", "Barnala", "Batala", "Bathinda", "Budhlada",
    "Dasuya", "Dhuri", "Dinanagar", "Faridkot", "Fazilka", "Firozpur", "Firozpur Cantt",
    "Gobindgarh", "Gurdaspur", "Hoshiarpur", "Jagraon", "Jalalabad", "Jalandhar",
    "Kapurthala", "Khanna", "Kharar", "Kot Kapura", "Kurali", "Longowal", "Ludhiana",
    "Malerkotla", "Malout", "Mandi Gobindgarh", "Mansa", "Maur", "Moga",
    "Mohali (SAS Nagar)", "Morinda", "Mukerian", "Muktsar", "Nabha", "Nakodar",
    "Nangal", "Nawanshahr", "Pathankot", "Patiala", "Patran", "Patti", "Phagwara",
    "Phillaur", "Qadian", "Raikot", "Rajpura", "Rampura Phul", "Rupnagar", "Samana",
    "Sangrur", "Sirhind", "Sujanpur", "Sunam", "Talwandi Sabo", "Tarn Taran",
    "Urmar Tanda", "Zirakpur"
  ],
  "Rajasthan": [
    "Abu Road", "Ajmer", "Alwar", "Anupgarh", "Balotra", "Banswara", "Baran", "Bari",
    "Barmer", "Beawar", "Bharatpur", "Bhilwara", "Bhinmal", "Bikaner", "Bundi",
    "Chhabra", "Chittorgarh", "Churu", "Dausa", "Deeg", "Dholpur", "Didwana",
    "Dungarpur", "Fatehpur", "Gangapur City", "Hanumangarh", "Hindaun", "Jaipur",
    "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Kaman", "Kapasan",
    "Kekri", "Kishangarh", "Kota", "Kotputli", "Kuchaman City", "Ladnun", "Lalsot",
    "Makrana", "Mount Abu", "Nagaur", "Nasirabad", "Nathdwara", "Nawalgarh",
    "Neem Ka Thana", "Nimbahera", "Nokha", "Pali", "Phalodi", "Pilani", "Pilibanga",
    "Pratapgarh", "Rajsamand", "Ramganj Mandi", "Ratangarh", "Rawatbhata", "Sadulpur",
    "Salumbar", "Sambhar", "Sanchore", "Sardarshahar", "Sawai Madhopur", "Shahpura",
    "Sheoganj", "Sikar", "Sirohi", "Sojat", "Sri Ganganagar", "Sujangarh", "Suratgarh",
    "Tijara", "Tonk", "Udaipur"
  ],
  "Sikkim": [
    "Gangtok", "Geyzing (Gyalshing)", "Jorethang", "Mangan", "Namchi", "Nayabazar",
    "Pakyong", "Rangpo", "Rhenock", "Singtam", "Soreng", "Yuksom"
  ],
  "Tamil Nadu": [
    "Ambasamudram", "Ambur", "Arakkonam", "Arani", "Ariyalur", "Aruppukkottai", "Attur",
    "Avadi", "Bhavani", "Bodinayakanur", "Chengalpattu", "Chennai", "Chidambaram",
    "Coimbatore", "Coonoor", "Cuddalore", "Dharapuram", "Dharmapuri", "Dindigul",
    "Erode", "Gobichetipalayam", "Gudiyatham", "Hosur", "Idappadi", "Kadayanallur",
    "Kallakurichi", "Kanchipuram", "Karaikudi", "Karur", "Kodaikanal", "Kovilpatti",
    "Krishnagiri", "Kulithalai", "Kumbakonam", "Madurai", "Manapparai", "Mannargudi",
    "Mayiladuthurai", "Mettupalayam", "Mettur", "Nagapattinam", "Nagercoil", "Namakkal",
    "Neyveli", "Ooty (Udhagamandalam)", "Palani", "Palladam", "Panruti", "Paramakudi",
    "Pattukkottai", "Perambalur", "Periyakulam", "Pollachi", "Pudukkottai", "Puliyankudi",
    "Rajapalayam", "Ramanathapuram", "Rameshwaram", "Ranipet", "Rasipuram", "Salem",
    "Sankarankovil", "Sathyamangalam", "Sirkazhi", "Sivaganga", "Sivakasi", "Srivilliputhur",
    "Tambaram", "Tenkasi", "Thanjavur", "Theni", "Thirumangalam", "Thiruthuraipoondi",
    "Thiruvallur", "Thiruvarur", "Thoothukudi (Tuticorin)", "Tindivanam", "Tiruchendur",
    "Tiruchengode", "Tiruchirappalli (Trichy)", "Tirunelveli", "Tirupathur", "Tiruppur",
    "Tiruttani", "Tiruvannamalai", "Tiruverkadu", "Udumalaipettai", "Valparai",
    "Vaniyambadi", "Vedaranyam", "Vellore", "Vikramasingapuram", "Viluppuram",
    "Virudhachalam", "Virudhunagar"
  ],
  "Telangana": [
    "Adilabad", "Armoor", "Bellampalli", "Bhadrachalam", "Bhainsa", "Bhongir (Bhuvanagiri)",
    "Bodhan", "Devarakonda", "Gadwal", "Gajwel", "Hyderabad", "Jagtial", "Jangaon",
    "Kagaznagar", "Kamareddy", "Karimnagar", "Khammam", "Koratla", "Kothagudem",
    "Kyathampally", "Madhira", "Mahabubabad", "Mahabubnagar", "Mancherial", "Mandamarri",
    "Medak", "Medchal", "Miryalaguda", "Nagarkurnool", "Nalgonda", "Narayanpet",
    "Nirmal", "Nizamabad", "Palwancha", "Peddapalli", "Ramagundam", "Sadashivpet",
    "Sangareddy", "Sathupalli", "Secunderabad", "Siddipet", "Sircilla", "Suryapet",
    "Tandur", "Vikarabad", "Wanaparthy", "Warangal", "Yellandu", "Zahirabad"
  ],
  "Tripura": [
    "Agartala", "Ambassa", "Belonia", "Bishalgarh", "Dharmanagar", "Kailashahar",
    "Kamalpur", "Khowai", "Melaghar", "Mohanpur", "Ranirbazar", "Sabroom",
    "Santirbazar", "Sonamura", "Teliamura", "Udaipur"
  ],
  "Uttar Pradesh": [
    "Agra", "Aligarh", "Allahabad (Prayagraj)", "Ambedkar Nagar", "Amethi", "Amroha",
    "Auraiya", "Ayodhya (Faizabad)", "Azamgarh", "Baghpat", "Bahraich", "Ballia",
    "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bhadohi", "Bijnor",
    "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah",
    "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddha Nagar", "Ghaziabad",
    "Ghazipur", "Gonda", "Gorakhpur", "Greater Noida", "Hapur", "Hardoi", "Hathras",
    "Jalaun", "Jaunpur", "Jhansi", "Kannauj", "Kanpur", "Kanpur Dehat", "Kasganj",
    "Kaushambi", "Kushinagar", "Lakhimpur Kheri", "Lalitpur", "Lucknow", "Maharajganj",
    "Mahoba", "Mainpuri", "Mathura", "Mau", "Meerut", "Mirzapur", "Modinagar",
    "Moradabad", "Muzaffarnagar", "Nawabganj", "Noida", "Orai", "Pilibhit",
    "Pratapgarh", "Raebareli", "Rampur", "Saharanpur", "Sambhal", "Sant Kabir Nagar",
    "Shahjahanpur", "Shamli", "Shravasti", "Siddharthnagar", "Sitapur", "Sonbhadra",
    "Sultanpur", "Unnao", "Varanasi", "Vrindavan"
  ],
  "Uttarakhand": [
    "Almora", "Bageshwar", "Barkot", "Bazpur", "Chamoli", "Champawat", "Dehradun",
    "Devprayag", "Doiwala", "Gopeshwar", "Haldwani", "Haridwar", "Herbertpur",
    "Jaspur", "Joshimath", "Kashipur", "Khatima", "Kichha", "Kotdwar", "Lalkuan",
    "Manglaur", "Mussoorie", "Nainital", "Pauri", "Pithoragarh", "Ramnagar",
    "Rishikesh", "Roorkee", "Rudraprayag", "Rudrapur", "Sitarganj", "Srinagar (Garhwal)",
    "Tehri", "Uttarkashi", "Vikasnagar"
  ],
  "West Bengal": [
    "Alipurduar", "Arambagh", "Asansol", "Ashoknagar Kalyangarh", "Baharampur",
    "Balurghat", "Bangaon", "Bankura", "Baranagar", "Barasat", "Bardhaman (Burdwan)",
    "Barrackpore", "Basirhat", "Bhadreswar", "Bhatpara", "Bishnupur", "Bolpur",
    "Budge Budge", "Chakdaha", "Champdani", "Chandannagar", "Contai", "Cooch Behar",
    "Darjeeling", "Dhulian", "Diamond Harbour", "Dinhata", "Dum Dum", "Durgapur",
    "English Bazar (Malda)", "Gangarampur", "Ghatal", "Gobra", "Habra", "Haldia",
    "Halisahar", "Howrah", "Islampur", "Jalpaiguri", "Jangipur", "Jhargram", "Kalyani",
    "Kamarhati", "Kanchrapara", "Kandi", "Kharagpur", "Khardaha", "Kolkata",
    "Krishnanagar", "Kurseong", "Madhyamgram", "Maheshtala", "Malda",
    "Medinipur (Midnapore)", "Memari", "Midnapore", "Murshidabad", "Nabadwip",
    "Naihati", "North Barrackpore", "North Dumdum", "Panihati", "Pujali", "Purulia",
    "Raghunathpur", "Raiganj", "Rampurhat", "Ranaghat", "Rishra", "Santipur",
    "Serampore", "Siliguri", "Sonamukhi", "South Dumdum", "Suri", "Taherpur", "Taki",
    "Tamluk", "Tarakeswar", "Titagarh", "Uluberia", "Uttarpara Kotrung"
  ],
};

// ─── Legacy alias list kept ONLY for cleanStateForShiprocket normalization ───
// (not shown in UI anymore — State dropdown now uses INDIAN_STATES_LIST directly)
const _LEGACY_STATE_ALIASES = {
  "bangalore": "Karnataka", "bengaluru": "Karnataka",
  "chennai": "Tamil Nadu", "madras": "Tamil Nadu",
  "hyderabad": "Telangana", "secunderabad": "Telangana",
  "mumbai": "Maharashtra", "bombay": "Maharashtra", "pune": "Maharashtra",
  "new delhi": "Delhi", "ncr": "Delhi",
  "ahmedabad": "Gujarat", "surat": "Gujarat",
  "kolkata": "West Bengal", "calcutta": "West Bengal",
  "lucknow": "Uttar Pradesh", "kanpur": "Uttar Pradesh", "noida": "Uttar Pradesh",
  "jaipur": "Rajasthan", "jodhpur": "Rajasthan",
  "kochi": "Kerala", "cochin": "Kerala", "trivandrum": "Kerala", "thiruvananthapuram": "Kerala",
  "visakhapatnam": "Andhra Pradesh", "vizag": "Andhra Pradesh",
  "guwahati": "Assam", "patna": "Bihar", "ranchi": "Jharkhand",
  "bhopal": "Madhya Pradesh", "indore": "Madhya Pradesh",
  "raipur": "Chhattisgarh", "panaji": "Goa", "panjim": "Goa",
  "shimla": "Himachal Pradesh", "dehradun": "Uttarakhand",
  "leh": "Ladakh", "kargil": "Ladakh",
  "amritsar": "Punjab", "ludhiana": "Punjab",
  "gurgaon": "Haryana", "gurugram": "Haryana", "faridabad": "Haryana",
  "srinagar": "Jammu and Kashmir", "jammu": "Jammu and Kashmir",
  "imphal": "Manipur", "shillong": "Meghalaya",
  "aizawl": "Mizoram", "kohima": "Nagaland",
  "bhubaneswar": "Odisha", "orissa": "Odisha",
  "pondicherry": "Puducherry", "pondy": "Puducherry",
  "port blair": "Andaman and Nicobar Islands",
  "gangtok": "Sikkim", "agartala": "Tripura",
  "silvassa": "Dadra and Nagar Haveli and Daman and Diu",
  "daman": "Dadra and Nagar Haveli and Daman and Diu",
  "kavaratti": "Lakshadweep",
  "itanagar": "Arunachal Pradesh",
  "dimapur": "Nagaland",
};

// ─── Helper: normalize any raw state string to Shiprocket-compliant official name ───
export const cleanStateForShiprocket = (rawState) => {
  if (!rawState || typeof rawState !== "string") return "";
  const trimmed = rawState.trim();
  if (!trimmed) return "";

  // 1. Direct exact match against clean state list
  const exactMatch = INDIAN_STATES_LIST.find(
    (s) => s.toLowerCase() === trimmed.toLowerCase()
  );
  if (exactMatch) return exactMatch;

  // 2. Match via legacy alias map
  const lower = trimmed.toLowerCase();
  if (_LEGACY_STATE_ALIASES[lower]) return _LEGACY_STATE_ALIASES[lower];

  // 3. Partial keyword scan of alias map
  for (const [alias, state] of Object.entries(_LEGACY_STATE_ALIASES)) {
    if (lower.includes(alias)) return state;
  }

  // 4. Partial match against state list itself
  const partialMatch = INDIAN_STATES_LIST.find(
    (s) => s.toLowerCase().includes(lower) || lower.includes(s.toLowerCase())
  );
  if (partialMatch) return partialMatch;

  // 5. Strip parentheses and retry
  const beforeParens = trimmed.replace(/\s*\([^)]*\).*/g, "").trim();
  if (beforeParens && beforeParens !== trimmed) {
    return cleanStateForShiprocket(beforeParens);
  }

  return trimmed;
};

// ─── State Dropdown — shows all 36 Indian States/UTs cleanly ───
const StateDropdown = ({ value, onChange, name, hasError, placeholder = "Select a state" }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);

  const cleanQ = query.trim().toLowerCase();
  const filtered = cleanQ
    ? INDIAN_STATES_LIST.filter((s) => s.toLowerCase().includes(cleanQ))
    : INDIAN_STATES_LIST;

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Focus search when opened
  useEffect(() => {
    if (open && searchRef.current) searchRef.current.focus();
  }, [open]);

  const handleSelect = (stateName) => {
    onChange({ target: { name, value: stateName } });
    setOpen(false);
    setQuery("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") { setOpen(false); setQuery(""); }
  };

  const displayLabel = value || placeholder;

  return (
    <div
      className={`state-dropdown-wrapper${hasError ? " state-dropdown-error" : ""}`}
      ref={wrapperRef}
    >
      <button
        type="button"
        className={`state-dropdown-trigger${open ? " open" : ""}${!value ? " placeholder" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{displayLabel}</span>
        <svg
          className={`state-dropdown-chevron${open ? " open" : ""}`}
          width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="state-dropdown-panel" role="listbox" onKeyDown={handleKeyDown}>
          <div className="state-dropdown-search-wrap">
            <svg className="state-search-icon" width="15" height="15" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" strokeWidth="2.2"
              strokeLinecap="round" strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              ref={searchRef}
              type="text"
              className="state-dropdown-search"
              placeholder="Search state..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            {query && (
              <button
                type="button"
                className="state-search-clear"
                onClick={() => setQuery("")}
                tabIndex={-1}
                aria-label="Clear search"
                style={{ alignSelf: "center", display: "flex", alignItems: "center",
                  justifyContent: "center", margin: 0, padding: 0,
                  background: "transparent", border: "none" }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="#000000" strokeWidth="2.5" strokeLinecap="round"
                  strokeLinejoin="round" style={{ display: "block" }}
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            )}
          </div>
          <ul className="state-dropdown-list">
            {filtered.length === 0 ? (
              <li className="state-dropdown-no-results">No states found</li>
            ) : (
              filtered.map((stateName) => (
                <li
                  key={stateName}
                  role="option"
                  aria-selected={stateName === value}
                  className={`state-dropdown-item${stateName === value ? " selected" : ""}`}
                  onClick={() => handleSelect(stateName)}
                >
                  <span>{stateName}</span>
                  {stateName === value && (
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5"
                      strokeLinecap="round" strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

// ─── City Dropdown — shows all cities for the chosen state ───
const CityDropdown = ({ stateValue, cityValue, onCityChange, cityName = "city", hasError, placeholder = "Select a city" }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapperRef = useRef(null);
  const searchRef = useRef(null);

  const cities = stateValue ? (CITIES_BY_STATE[stateValue] || []) : [];

  const cleanQ = query.trim().toLowerCase();
  const filtered = cleanQ
    ? cities.filter((c) => c.toLowerCase().includes(cleanQ))
    : cities;

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  // Focus search when opened
  useEffect(() => {
    if (open && searchRef.current) searchRef.current.focus();
  }, [open]);

  const handleSelect = (city) => {
    onCityChange({ target: { name: cityName, value: city } });
    setOpen(false);
    setQuery("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") { setOpen(false); setQuery(""); }
  };

  // No state chosen yet
  if (!stateValue) {
    return (
      <div className="state-dropdown-wrapper city-dropdown-disabled">
        <div className="state-dropdown-trigger placeholder" style={{ cursor: "not-allowed", opacity: 0.55 }}>
          <span>Select state first</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </div>
    );
  }

  const displayLabel = cityValue || placeholder;

  return (
    <div
      className={`state-dropdown-wrapper${hasError ? " state-dropdown-error" : ""}`}
      ref={wrapperRef}
    >
      <button
        type="button"
        className={`state-dropdown-trigger${open ? " open" : ""}${!cityValue ? " placeholder" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{displayLabel}</span>
        <svg
          className={`state-dropdown-chevron${open ? " open" : ""}`}
          width="14" height="14" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" strokeWidth="2.5"
          strokeLinecap="round" strokeLinejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="state-dropdown-panel" role="listbox" onKeyDown={handleKeyDown}>
          <div className="state-dropdown-search-wrap">
            <svg className="state-search-icon" width="15" height="15" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" strokeWidth="2.2"
              strokeLinecap="round" strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              ref={searchRef}
              type="text"
              className="state-dropdown-search"
              placeholder="Search city..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            {query && (
              <button
                type="button"
                className="state-search-clear"
                onClick={() => setQuery("")}
                tabIndex={-1}
                aria-label="Clear search"
                style={{ alignSelf: "center", display: "flex", alignItems: "center",
                  justifyContent: "center", margin: 0, padding: 0,
                  background: "transparent", border: "none" }}
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="#000000" strokeWidth="2.5" strokeLinecap="round"
                  strokeLinejoin="round" style={{ display: "block" }}
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            )}
          </div>
          <ul className="state-dropdown-list">
            {filtered.length === 0 ? (
              <li className="state-dropdown-no-results">No cities found</li>
            ) : (
              filtered.map((city) => (
                <li
                  key={city}
                  role="option"
                  aria-selected={city === cityValue}
                  className={`state-dropdown-item${city === cityValue ? " selected" : ""}`}
                  onClick={() => handleSelect(city)}
                >
                  <span>{city}</span>
                  {city === cityValue && (
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5"
                      strokeLinecap="round" strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  )}
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
};



const unwrapApiData = (response) => {
  const body = response?.data;
  if (body && typeof body === "object" && "success" in body) {
    if (!body.success) {
      throw new Error(body.message || "Request failed");
    }
    return body.data ?? body;
  }
  return body;
};

const getApiErrorMessage = (err, fallback = "Request failed") => {
  const data = err?.response?.data;
  if (typeof data === "string") return data;
  return data?.message || err?.message || fallback;
};

const Checkout = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isAddressDropdownOpen, setIsAddressDropdownOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    fullName: "",
    address: "",
    appartment: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    email: "",
    country: "India",
    emailNewsOffers: false,
    packageLength: 10, // Default Shiprocket fields
    packageWidth: 10,
    packageHeight: 10,
    packageWeight: 0.5,
    pickupLocation: "Aminii clothing ",
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editAddressId, setEditAddressId] = useState(null);
  const [isFormCollapsed, setIsFormCollapsed] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  // Payment method selection removed — orders are placed directly (pay on enquiry / COD).
  const [paymentType, setPaymentType] = useState("ONLINE_PAYMENT");
  const [billingSameAsShipping, setBillingSameAsShipping] = useState(true);
  const [saveContactInfo, setSaveContactInfo] = useState(false);
  const [textOffers, setTextOffers] = useState(false);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [orderSuccess, setOrderSuccess] = useState(false);
  const [placedOrderId, setPlacedOrderId] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState(null);
  const [razorpayOrderId, setRazorpayOrderId] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showGuestAddressModal, setShowGuestAddressModal] = useState(false);
  const [codAvailable, setCodAvailable] = useState(null);
  const [isCheckingCod, setIsCheckingCod] = useState(false);
  const [codMessage, setCodMessage] = useState("");
  const [billingFormData, setBillingFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    apartment: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    country: "India",
  });
  const [isDetectingLocation, setIsDetectingLocation] = useState(false);

  const handleDetectLocation = (target = "shipping") => {
    if (!navigator.geolocation) {
      showErrorPopup("Geolocation is not supported by your browser.");
      return;
    }

    setIsDetectingLocation(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const { latitude, longitude } = position.coords;
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`
          );
          const data = await response.json();
          if (data && data.address) {
            const addr = data.address;
            const detectedState = cleanStateForShiprocket(addr.state || "Karnataka");
            const detectedCity = addr.city || addr.town || addr.village || addr.county || "";
            const detectedZip = addr.postcode ? addr.postcode.replace(/\s+/g, "") : "";
            const detectedRoad = [addr.house_number, addr.road, addr.suburb].filter(Boolean).join(", ") || (data.display_name ? data.display_name.split(",")[0] : "");

            if (target === "billing") {
              setBillingFormData((prev) => ({
                ...prev,
                address: detectedRoad || prev.address,
                city: detectedCity || prev.city,
                state: detectedState || prev.state,
                zip: detectedZip || prev.zip,
              }));
            } else {
              setFormData((prev) => ({
                ...prev,
                address: detectedRoad || prev.address,
                city: detectedCity || prev.city,
                state: detectedState || prev.state,
                zip: detectedZip || prev.zip,
              }));
              if (detectedZip) {
                checkCodAvailability(detectedZip);
              }
            }
          } else {
            showErrorPopup("Could not determine address details from location.");
          }
        } catch (err) {
          console.error("Location detection error:", err);
          showErrorPopup("Failed to fetch address for your location.");
        } finally {
          setIsDetectingLocation(false);
        }
      },
      (error) => {
        setIsDetectingLocation(false);
        if (error.code === error.PERMISSION_DENIED) {
          showErrorPopup("Location access denied. Please enable location permissions in browser.");
        } else {
          showErrorPopup("Unable to retrieve location.");
        }
      },
      { timeout: 10000, enableHighAccuracy: true }
    );
  };

  const checkCodAvailability = async (pincodeToTest) => {
    if (!pincodeToTest || !pincodeToTest.toString().trim()) {
      setCodAvailable(null);
      setCodMessage("");
      return;
    }
    const cleanZip = pincodeToTest.toString().trim();
    if (cleanZip.length < 3) {
      setCodAvailable(null);
      setCodMessage("");
      return;
    }

    setIsCheckingCod(true);
    try {
      const res = await axios.post(`${API_BASE_URL}/check-cod-availability`, {
        pincode: cleanZip,
      });
      const data = res.data?.data || res.data;
      const isAvailable = Boolean(data?.codAvailable);
      setCodAvailable(isAvailable);
      if (!isAvailable) {
        if (paymentType === "COD") {
          setPaymentType("ONLINE_PAYMENT");
        }
        showErrorPopup(`Cash on Delivery (COD) is not available for PIN ${cleanZip}. COD payment option has been disabled; please proceed with Online Payment.`);
      }
    } catch (err) {
      setCodAvailable(false);
      if (paymentType === "COD") {
        setPaymentType("ONLINE_PAYMENT");
      }
      showErrorPopup(`Cash on Delivery (COD) is not available (${cleanZip}) for this location. COD payment option has been disabled; please proceed with Online Payment.`);
    } finally {
      setIsCheckingCod(false);
    }
  };

  useEffect(() => {
    if (formData.zip && formData.zip.trim().length >= 4) {
      const timer = setTimeout(() => {
        checkCodAvailability(formData.zip);
      }, 400);
      return () => clearTimeout(timer);
    } else if (!isLoggedIn) {
      setCodAvailable(null);
      setCodMessage("");
    }
  }, [formData.zip]);

  useEffect(() => {
    if (isLoggedIn && selectedAddressId && addresses.length > 0) {
      const selAddr = addresses.find((a) => a.userDetailsId === selectedAddressId) || addresses[0];
      if (selAddr && selAddr.zip) {
        checkCodAvailability(selAddr.zip.toString());
      }
    }
  }, [selectedAddressId, addresses, isLoggedIn]);
  const isOnlinePayment = (type = paymentType) => {
    const normalized = (type || "").toUpperCase();
    return (
      normalized === "ONLINE_PAYMENT" ||
      normalized === "UPI" ||
      normalized === "RAZORPAY"
    );
  };

  const clearStaleAuth = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("userId");
    localStorage.removeItem("userFirstName");
    setIsLoggedIn(false);
    setUserId(null);
  };

  const hasValidSession = () => {
    const token = localStorage.getItem("token");
    if (!token || isTokenExpired(token)) return false;
    const payload = decodeJwtPayload(token);
    return Boolean(payload?.userId);
  };

  const getOptionalAuthHeaders = () => {
    const token = localStorage.getItem("token");
    if (token && !isTokenExpired(token)) {
      return { Authorization: `Bearer ${token}` };
    }
    return {};
  };

  const openRazorpayCheckout = async ({ order, prefill, onSuccess }) => {
    const keyResponse = await api.get("/razorpay-key");
    const keyId =
      typeof keyResponse.data === "string"
        ? keyResponse.data
        : keyResponse.data?.data || keyResponse.data?.keyId;

    if (!keyId || String(keyId).toLowerCase().includes("not configured")) {
      throw new Error(
        "Online payment is unavailable right now. Please choose Cash on Delivery."
      );
    }

    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      throw new Error("Failed to load payment gateway.");
    }

    const { total } = calculateTotals();
    const rzOrderId = order?.razorpayOrderId;
    if (!rzOrderId) {
      throw new Error("Payment order was not created. Please try again.");
    }

    setRazorpayOrderId(rzOrderId);

    await new Promise((resolve, reject) => {
      const options = {
        key: keyId,
        order_id: rzOrderId,
        amount: Math.round(parseFloat(total) * 100).toString(),
        currency: "INR",
        name: "Aminii Clothing",
        description: "Order Payment",
        prefill: prefill || {},
        theme: { color: "#1a1a1a" },
        config: {
          display: {
            hide: [
              { method: "emi" },
              { method: "paylater" },
            ],
            preferences: { show_default_blocks: true },
          },
        },
        handler: async (response) => {
          try {
            await api.post("/verify-payment", {
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              payment_method: paymentType || "RAZORPAY",
              created_at: Math.floor(Date.now() / 1000),
            });
            await onSuccess?.();
            resolve(response);
          } catch (err) {
            showErrorPopup(
              "Payment verification failed: " + getApiErrorMessage(err),
              true,
              rzOrderId
            );
            reject(err);
          }
        },
        modal: {
          ondismiss: async () => {
            try {
              await api.post("/payment-failed", {
                razorpayOrderId: rzOrderId,
                razorpayPaymentId: "pay_manual_cancel",
                error_description: "Payment cancelled by user",
              });
            } catch (_) {
              /* ignore */
            }
            showErrorPopup("Payment cancelled.", true, rzOrderId);
            reject(new Error("cancelled"));
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", async (response) => {
        try {
          await api.post("/payment-failed", {
            razorpayOrderId: response.error.metadata.order_id,
            razorpayPaymentId: response.error.metadata.payment_id,
            error_description: response.error.description,
          });
        } catch (_) {
          /* ignore */
        }
        showErrorPopup(
          `Payment failed: ${response.error.description}`,
          true,
          rzOrderId
        );
        reject(response.error);
      });
      rzp.open();
    });
  };

  const renderPaymentAndBilling = () => (
    <>
      <div className="checkout-block checkout-payment-section">
        <h3 className="checkout-block-title">Payments</h3>
        <p className="checkout-block-subtitle">
          All transactions are secure and encrypted.
        </p>
        <div className="checkout-option-group">
          <div
            className={`checkout-option-row ${
              isOnlinePayment() ? "is-selected" : ""
            }`}
            onClick={() => setPaymentType("ONLINE_PAYMENT")}
          >
            {/* Radio dot indicator */}
            <span className={`checkout-radio-dot ${isOnlinePayment() ? "checked" : ""}`} />
            <span className="checkout-option-content">
              <span className="checkout-option-label">
                <span>Razorpay (UPI, Cards, Int&apos;l cards, Wallets)</span>
                {/* UPI app icons */}
                <span className="checkout-upi-icons">
                  {/* Google Pay */}
                  <img
                    src="https://img.icons8.com/?size=100&id=am4ltuIYDpQ5&format=png&color=000000"
                    alt="Google Pay"
                    width="24"
                    height="24"
                    style={{ display: "inline-block", verticalAlign: "middle", borderRadius: "4px" }}
                  />
                  {/* PhonePe */}
                  <img
                    src="https://img.icons8.com/?size=100&id=OYtBxIlJwMGA&format=png&color=000000"
                    alt="PhonePe"
                    width="24"
                    height="24"
                    style={{ display: "inline-block", verticalAlign: "middle", borderRadius: "4px" }}
                  />
                </span>
              </span>
              <span className="checkout-payment-badges">
                <span>UPI</span>
                <span>VISA</span>
                <span>MC</span>
                <span className="checkout-badge-more">+11</span>
              </span>
            </span>
          </div>
          {isOnlinePayment() && (
            <p className="checkout-option-notice">
              You&apos;ll be redirected to Razorpay (UPI, Cards, Int&apos;l
              cards, Wallets) to complete your purchase.
            </p>
          )}
          <div
            className={`checkout-option-row ${
              paymentType === "COD" ? "is-selected" : ""
            } ${codAvailable === false ? "is-disabled" : ""}`}
            style={
              codAvailable === false
                ? { opacity: 0.45, cursor: "not-allowed" }
                : {}
            }
            onClick={() => {
              if (codAvailable === false) {
                showErrorPopup("Cash on Delivery (COD) is not available for your delivery PIN code. Please select Online Payment.");
                return;
              }
              setPaymentType("COD");
            }}
          >
            {/* Radio dot indicator */}
            <span className={`checkout-radio-dot ${paymentType === "COD" ? "checked" : ""}`} />
            <span className="checkout-option-label" style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
              <span>Cash on Delivery (Inc. 150)</span>
              {codAvailable === false && (
                <span style={{ color: "#ef4444", fontSize: "12px", fontWeight: "600", backgroundColor: "#fee2e2", padding: "2px 8px", borderRadius: "4px" }}>
                  Unavailable for this location
                </span>
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="checkout-block checkout-billing-section">
        <h3 className="checkout-block-title">Billing address</h3>
        <div className="checkout-option-group">
          <div
            className={`checkout-option-row ${
              billingSameAsShipping ? "is-selected" : ""
            }`}
            onClick={() => setBillingSameAsShipping(true)}
          >
            <span className={`checkout-radio-dot ${billingSameAsShipping ? "checked" : ""}`} />
            <span className="checkout-option-label">Same as shipping address</span>
          </div>
          <div
            className={`checkout-option-row ${
              !billingSameAsShipping ? "is-selected" : ""
            }`}
            onClick={() => setBillingSameAsShipping(false)}
          >
            <span className={`checkout-radio-dot ${!billingSameAsShipping ? "checked" : ""}`} />
            <span className="checkout-option-label">
              Use a different billing address
            </span>
          </div>
        </div>

        {!billingSameAsShipping && (
          <div className="different-billing-address-form" style={{ marginTop: "16px", padding: "16px", backgroundColor: "#f9fafb", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
            <div className="checkout-section-header-row" style={{ marginBottom: "12px" }}>
              <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#111827", flex: 1, minWidth: 0 }}>Custom Billing Address</h4>
              <button
                type="button"
                className={`location-detect-btn${isDetectingLocation ? " is-detecting" : ""}`}
                onClick={() => handleDetectLocation("billing")}
                disabled={isDetectingLocation}
                aria-label="Auto-fill billing address from current location"
              >
                <span className="loc-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" fill="currentColor"/>
                  </svg>
                </span>
                <span className="loc-label">{isDetectingLocation ? "Detecting..." : "Use Current Location"}</span>
              </button>
            </div>


            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
              <div className="form-group">
                <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px", display: "block" }}>First name</label>
                <input
                  type="text"
                  placeholder="First name"
                  value={billingFormData.firstName}
                  onChange={(e) => setBillingFormData({ ...billingFormData, firstName: e.target.value })}
                  style={{ width: "100%", padding: "8px 12px", borderRadius: "4px", border: "1px solid #d1d5db" }}
                />
              </div>
              <div className="form-group">
                <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px", display: "block" }}>Last name</label>
                <input
                  type="text"
                  placeholder="Last name"
                  value={billingFormData.lastName}
                  onChange={(e) => setBillingFormData({ ...billingFormData, lastName: e.target.value })}
                  style={{ width: "100%", padding: "8px 12px", borderRadius: "4px", border: "1px solid #d1d5db" }}
                />
              </div>
            </div>

            <div className="form-group" style={{ marginBottom: "12px" }}>
              <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px", display: "block" }}>Address</label>
              <input
                type="text"
                placeholder="Street Address, House No., Building"
                value={billingFormData.address}
                onChange={(e) => setBillingFormData({ ...billingFormData, address: e.target.value })}
                style={{ width: "100%", padding: "8px 12px", borderRadius: "4px", border: "1px solid #d1d5db" }}
              />
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
              <div className="form-group">
                <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px", display: "block" }}>State</label>
                <StateDropdown
                  name="state"
                  value={billingFormData.state}
                  onChange={(e) => setBillingFormData((prev) => ({ ...prev, state: e.target.value }))}
                  placeholder="Select a state"
                />
              </div>
              <div className="form-group">
                <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px", display: "block" }}>City</label>
                {/* <CityDropdown
                  stateValue={billingFormData.state}
                  cityValue={billingFormData.city}
                  onCityChange={(e) => setBillingFormData((prev) => ({ ...prev, city: e.target.value }))}
                  cityName="city"
                /> */}
                <input
                  type="text"
                  placeholder="City"
                  value={billingFormData.city}
                  onChange={(e) => setBillingFormData({ ...billingFormData, city: e.target.value })}
                  style={{ width: "100%", padding: "8px 12px", borderRadius: "4px", border: "1px solid #d1d5db" }}
                />
              </div>
              <div className="form-group">
                <label style={{ fontSize: "12px", fontWeight: "500", marginBottom: "4px", display: "block" }}>PIN code</label>
                <input
                  type="text"
                  placeholder="PIN code"
                  value={billingFormData.zip}
                  onChange={(e) => setBillingFormData({ ...billingFormData, zip: e.target.value })}
                  style={{ width: "100%", padding: "8px 12px", borderRadius: "4px", border: "1px solid #d1d5db" }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );

  const hasShippingDetails = () => {
    const isGuest = !hasValidSession();
    if (isGuest) {
      return (
        formData.address.trim() &&
        formData.city.trim() &&
        formData.state &&
        formData.zip.trim()
      );
    }
    return Boolean(selectedAddressId);
  };

  const renderShippingMethod = () => (
    <div className="checkout-block checkout-shipping-method-section">
      <h3 className="checkout-block-title">Shipping method</h3>
      {hasShippingDetails() ? (
        <div className="checkout-shipping-method-box checkout-shipping-method-box--ready">
          Standard shipping — Free
        </div>
      ) : (
        <div className="checkout-shipping-method-box">
          Enter your shipping address to view available shipping methods.
        </div>
      )}
    </div>
  );

  const renderPayNowButton = () => (
    <button
      type="button"
      className="checkout-pay-now-btn"
      onClick={handlePlaceOrder}
      disabled={
        isPlacingOrder ||
        loading ||
        cartItems.length === 0 ||
        (hasValidSession() && !selectedAddressId)
      }
    >
      {isPlacingOrder
        ? "Processing..."
        : isOnlinePayment()
        ? "Pay now"
        : "Complete order"}
    </button>
  );

  const formRef = useRef(null);
  const navigate = useNavigate();

  const { state } = useLocation();
  const {
    cartItems: cartItemsFromState = [],
    promoCode = "",
    promoDiscount = 0,
  } = state || {};

  // Load cart: location.state > guest localStorage > server API
  useEffect(() => {
    const loadCart = async () => {
      if (cartItemsFromState.length > 0) {
        setCartItems(cartItemsFromState);
        setLoading(false);
        return;
      }

      const token = localStorage.getItem("token");
      const loggedIn =
        token && !isTokenExpired(token) && decodeJwtPayload(token)?.userId;

      if (!loggedIn) {
        const guestItems = getGuestCart();
        if (!guestItems.length) {
          navigate("/productList", {
            replace: true,
            state: { message: "Your cart is empty." },
          });
          return;
        }
        setCartItems(guestItems);
        setLoading(false);
        return;
      }

      const uid = decodeJwtPayload(token).userId;
      setUserId(uid);
      setIsLoggedIn(true);
      try {
        const cartResponse = await api.get(`/cart/user/${uid}`);
        const cartData = cartResponse.data?.data || cartResponse.data;
        if (!Array.isArray(cartData) || cartData.length === 0) {
          navigate("/productList", {
            replace: true,
            state: { message: "Your cart is empty." },
          });
          return;
        }
        const cartWithProductDetails = await Promise.all(
          cartData.map(async (cartItem) => {
            const productResponse = await api.get(
              `/products/${cartItem.productId}`
            );
            const product = productResponse.data?.data || productResponse.data;
            return {
              cartId: cartItem.cartId,
              productId: cartItem.productId,
              productName: product.productName,
              productImage:
                product.productImages?.[0] || "https://via.placeholder.com/50",
              productPrice: product.productPrice,
              beforeDiscountPrice:
                product.beforeDiscountPrice || product.productPrice,
              size: cartItem.cartSize,
              quantity: cartItem.cartQty,
              sku: product.sku || `SKU-${cartItem.productId}`,
              hsn: product.hsn || "6204",
            };
          })
        );
        setCartItems(cartWithProductDetails);
        setLoading(false);
      } catch (err) {
        setError("Failed to load cart.");
        setLoading(false);
      }
    };

    loadCart();
  }, []);

  const api = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
  });

  api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });

  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const getCookie = (name) => {
    try {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    } catch (error) {
      return null;
    }
  };

  const decodeJwtPayload = (token) => {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      return null;
    }
  };

  const isTokenExpired = (token) => {
    const payload = decodeJwtPayload(token);
    if (!payload?.exp) return true;
    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp < currentTime;
  };

  const refreshToken = async () => {
    const newToken = await refreshAccessToken();
    if (!newToken) return false;
    const payload = decodeJwtPayload(newToken);
    if (payload?.userId) {
      setUserId(payload.userId);
      return true;
    }
    return false;
  };

  const keepAlive = async () => {
    try {
      await api.get("/ping");
    } catch (error) {}
  };

  useEffect(() => {
    const jwtCookie = getCookie("jwt");
    let token = jwtCookie;

    if (jwtCookie) {
      localStorage.setItem("token", jwtCookie);
    } else {
      token = localStorage.getItem("token");
    }

    if (token) {
      if (isTokenExpired(token)) {
        refreshToken().then((refreshed) => {
          if (refreshed) {
            const newToken = localStorage.getItem("token");
            const payload = decodeJwtPayload(newToken);
            if (payload?.userId) {
              setUserId(payload.userId);
              setIsLoggedIn(true);
              localStorage.setItem("isLoggedIn", "true");
              localStorage.setItem("userId", payload.userId);
            } else {
              clearStaleAuth();
            }
          } else {
            clearStaleAuth();
          }
        });
      } else {
        const payload = decodeJwtPayload(token);
        if (payload?.userId) {
          setUserId(payload.userId);
          setIsLoggedIn(true);
          localStorage.setItem("isLoggedIn", "true");
          localStorage.setItem("userId", payload.userId);
        } else {
          clearStaleAuth();
        }
      }
    } else {
      clearStaleAuth();
    }

    const keepAliveInterval = setInterval(() => {
      if (localStorage.getItem("isLoggedIn") === "true") {
        keepAlive();
      }
    }, 600000);

    return () => clearInterval(keepAliveInterval);
  }, []);

  const fetchAddresses = async () => {
    if (!userId || !localStorage.getItem("token")) {
      showErrorPopup("Please log in to view your addresses.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (token && isTokenExpired(token)) {
        const refreshed = await refreshToken();
        if (!refreshed) {
          showErrorPopup("Session expired. Please log in again.");
          navigate("/login");
          return;
        }
      }

      const response = await api.get(`/userdetails/user/${userId}`);
      const addressData = unwrapApiData(response);
      if (!Array.isArray(addressData)) {
        setAddresses([]);
        setShowForm(true);
      } else {
        setAddresses(addressData);
        setShowForm(addressData.length === 0);
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setAddresses([]);
        setShowForm(true);
      } else if (err.response?.status === 401 || err.response?.status === 403) {
        const refreshed = await refreshToken();
        if (refreshed) {
          fetchAddresses();
        } else {
          showErrorPopup("Session expired. Please log in again.");
          navigate("/login");
        }
      } else {
        showErrorPopup(
          "Failed to load addresses: " +
            (err.response?.data?.message || err.message)
        );
      }
    }
  };

  const fetchCartItems = async (retryCount = 0) => {
    if (!userId || !localStorage.getItem("token")) {
      showErrorPopup("Please log in to access the checkout.");
      setError("Please log in to view your cart.");
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      if (token && isTokenExpired(token)) {
        const refreshed = await refreshToken();
        if (!refreshed) {
          showErrorPopup("Session expired. Please log in again.");
          navigate("/login");
          return;
        }
      }

      const cartResponse = await api.get(`/cart/user/${userId}`);
      const cartData = cartResponse.data?.data || cartResponse.data;

      if (!Array.isArray(cartData)) {
        setCartItems([]);
      } else {
        const cartWithProductDetails = await Promise.all(
          cartData.map(async (cartItem) => {
            const productResponse = await api.get(
              `/products/${cartItem.productId}`
            );
            const product = productResponse.data?.data || productResponse.data;
            return {
              cartId: cartItem.cartId,
              productId: cartItem.productId,
              productName: product.productName,
              productImage:
                product.productImages?.[0] || "https://via.placeholder.com/50",
              productPrice: product.productPrice,
              beforeDiscountPrice:
                product.beforeDiscountPrice || product.productPrice,
              size: cartItem.cartSize,
              quantity: cartItem.cartQty,
              sku: product.sku || `SKU-${cartItem.productId}`,
              hsn: product.hsn || "6204",
            };
          })
        );
        setCartItems(cartWithProductDetails);
      }
      setLoading(false);
      setError(null);
    } catch (err) {
      if (
        (err.response?.status === 401 || err.response?.status === 403) &&
        retryCount < 1
      ) {
        const refreshed = await refreshToken();
        if (refreshed) {
          return fetchCartItems(retryCount + 1); // Retry only once
        } else {
          showErrorPopup("Session expired. Please log in again.");
          navigate("/login");
        }
      } else if (err.response?.status === 404) {
        setCartItems([]);
        setLoading(false);
        setError(null);
      } else {
        setError(
          "Failed to load cart: " + (err.response?.data?.message || err.message)
        );
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (userId && isLoggedIn) {
      fetchAddresses();
    }
  }, [userId, isLoggedIn]);

  useEffect(() => {
    if (addresses.length > 0 && !selectedAddressId) {
      setSelectedAddressId(addresses[0].userDetailsId);
    }
  }, [addresses, selectedAddressId]);

  const showErrorPopup = (
    message,
    showRetry = false,
    razorpayOrderId = null
  ) => {
    setPopupMessage(message);
    setPopupType("error");
    setShowPopup(true);
    setRazorpayOrderId(razorpayOrderId);
  };

  const showSuccessPopup = (message, orderId, isGuest = false) => {
    setPopupMessage(message);
    setPopupType("success");
    setShowPopup(true);
    setOrderSuccess(true);
    setPlacedOrderId(orderId);
    if (!isGuest) {
      setTimeout(() => navigate(`/orders`), 2000);
    }
  };

  const handleImageError = (e) => {
    e.target.src = "https://via.placeholder.com/50";
    e.target.onerror = null;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;

    setFormData((prev) => {
      const updated = { ...prev, [name]: val };
      if (name === "firstName" || name === "lastName") {
        const fn = name === "firstName" ? val : prev.firstName || "";
        const ln = name === "lastName" ? val : prev.lastName || "";
        updated.fullName = `${fn} ${ln}`.trim();
      }
      return updated;
    });

    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (name === "firstName" && formErrors.fullName) {
      setFormErrors((prev) => ({ ...prev, fullName: "" }));
    }
  };

  const validateForm = () => {
    const { firstName, lastName, fullName, address, city, state, zip, phone, email } = formData;
    const newErrors = {};
    let isValid = true;

    const effName = (firstName || fullName || "").trim();
    if (!effName) {
      newErrors.firstName = "First name is required";
      isValid = false;
    }

    if (!address?.trim()) {
      newErrors.address = "Address is required";
      isValid = false;
    }

    if (!city?.trim()) {
      newErrors.city = "City is required";
      isValid = false;
    }

    if (!state) {
      newErrors.state = "State is required";
      isValid = false;
    }

    if (!zip?.trim()) {
      newErrors.zip = "PIN code is required";
      isValid = false;
    } else if (!/^\d{6}$/.test(zip.trim())) {
      newErrors.zip = "PIN code must be a 6-digit number";
      isValid = false;
    }

    if (!phone?.trim()) {
      newErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(phone.trim())) {
      newErrors.phone = "Phone number must be a 10-digit number";
      isValid = false;
    }

    if (!email?.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email.trim())) {
      newErrors.email = "Invalid email format";
      isValid = false;
    }

    setFormErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userId || !localStorage.getItem("token")) {
      showErrorPopup("Please log in to save your address.");
      return;
    }

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const token = localStorage.getItem("token");
      if (token && isTokenExpired(token)) {
        const refreshed = await refreshToken();
        if (!refreshed) {
          showErrorPopup("Session expired. Please log in again.");
          navigate("/login");
          return;
        }
      }

      const effectiveFullName = (
        formData.fullName ||
        `${formData.firstName || ""} ${formData.lastName || ""}`
      ).trim();

      const payload = {
        userId: parseInt(userId),
        fullName: effectiveFullName,
        address: formData.address,
        appartment: formData.appartment || null,
        city: formData.city,
        State: cleanStateForShiprocket(formData.state),
        zip: formData.zip.trim(),
        phone: formData.phone,
      };

      let savedAddress;
      if (editAddressId) {
        const response = await api.put(
          `/userdetails/${editAddressId}`,
          payload
        );
        savedAddress = unwrapApiData(response);
      } else {
        const response = await api.post("/userdetails", payload);
        savedAddress = unwrapApiData(response);
      }

      setFormData({
        firstName: "",
        lastName: "",
        fullName: "",
        address: "",
        appartment: "",
        city: "",
        state: "",
        zip: "",
        phone: "",
        email: "",
        country: "India",
        emailNewsOffers: false,
        packageLength: 10,
        packageWidth: 10,
        packageHeight: 10,
        packageWeight: 0.5,
        pickupLocation: "Aminii clothing ",
      });
      setEditAddressId(null);
      setShowForm(false);
      await fetchAddresses();
      if (savedAddress?.userDetailsId) {
        setSelectedAddressId(savedAddress.userDetailsId);
      }
      setPopupMessage("Address saved successfully.");
      setPopupType("success");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 2000);
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 403) {
        const refreshed = await refreshToken();
        if (refreshed) {
          handleSubmit(e);
        } else {
          showErrorPopup("Session expired. Please log in again.");
          navigate("/login");
        }
      } else {
        showErrorPopup("Failed to save address: " + getApiErrorMessage(err));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditAddress = (address, e) => {
    e?.stopPropagation?.();
    const parts = (address.fullName || "").trim().split(" ");
    const firstName = parts[0] || "";
    const lastName = parts.slice(1).join(" ") || "";

    setFormData({
      firstName,
      lastName,
      fullName: address.fullName,
      address: address.address,
      appartment: address.appartment || "",
      city: address.city,
      state: cleanStateForShiprocket(address.state || address.State || ""),
      zip: address.zip.toString(),
      phone: address.phone,
      email: address.userEmail || address.email || formData.email || "",
      country: "India",
      emailNewsOffers: false,
      packageLength: 10,
      packageWidth: 10,
      packageHeight: 10,
      packageWeight: 0.5,
      pickupLocation: "Aminii clothing ",
    });
    setEditAddressId(address.userDetailsId);
    setShowForm(true);
    setIsFormCollapsed(false);
    setFormErrors({});
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  const handleAddNewAddress = () => {
    setFormData((prev) => ({
      firstName: "",
      lastName: "",
      fullName: "",
      address: "",
      appartment: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      email: prev.email || "",
      country: "India",
      emailNewsOffers: false,
      packageLength: 10,
      packageWidth: 10,
      packageHeight: 10,
      packageWeight: 0.5,
      pickupLocation: "Aminii clothing ",
    }));
    setEditAddressId(null);
    setShowForm(true);
    setIsFormCollapsed(false);
    setFormErrors({});
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  const handleDeleteAddress = async (addressId, e) => {
    e?.stopPropagation?.();
    if (!window.confirm("Are you sure you want to remove this address?")) return;

    try {
      await api.delete(`/userdetails/${addressId}`);
      setAddresses((prev) => {
        const updated = prev.filter((a) => a.userDetailsId !== addressId);
        if (selectedAddressId === addressId) {
          if (updated.length > 0) {
            setSelectedAddressId(updated[0].userDetailsId);
          } else {
            setSelectedAddressId(null);
            setShowForm(true);
          }
        }
        return updated;
      });
    } catch (err) {
      showErrorPopup(err.response?.data?.message || "Failed to remove address.");
    }
  };

  const handleCardClick = (addressId) => {
    setSelectedAddressId(addressId);
    setIsAddressDropdownOpen(false);
  };

  // Fully close the address form (cancel add/edit)
  const handleCloseForm = () => {
    setShowForm(false);
    setEditAddressId(null);
    setIsFormCollapsed(false);
  };

  // Minimize/expand the form body while keeping it open
  const toggleFormCollapse = () => {
    setIsFormCollapsed((prev) => !prev);
  };

  const calculateTotals = () => {
    const originalSubtotal = cartItems
      .reduce(
        (total, item) => total + item.beforeDiscountPrice * item.quantity,
        0
      )
      .toFixed(2);
    const subtotal = cartItems
      .reduce((total, item) => total + item.productPrice * item.quantity, 0)
      .toFixed(2);
    const initialDiscount = (
      parseFloat(originalSubtotal) - parseFloat(subtotal)
    ).toFixed(2);
    const isCod = paymentType === "COD";
    const shipping = isCod ? 150 : 0;
    const appliedPromoDiscount = parseFloat(promoDiscount || 0);
    const total = (parseFloat(subtotal) - appliedPromoDiscount + shipping).toFixed(2);

    return {
      originalSubtotal,
      subtotal,
      initialDiscount,
      shipping,
      isCod,
      promoDiscount: appliedPromoDiscount,
      total,
    };
  };

  const closePopup = () => {
    setShowPopup(false);
    if (orderSuccess && isLoggedIn) {
      navigate("/orders");
    }
  };

  const buildStreetAddress = (street, apartment) => {
    if (!apartment?.trim()) return street;
    return `${street}, ${apartment.trim()}`;
  };

  const buildOrderPayload = ({
    customerName,
    customerEmail,
    customerPhone,
    street,
    city,
    state,
    pincode,
    orderUserId,
  }) => {
    const { date, time, dateTime } = getCurrentDateAndTime();
    const { subtotal, shipping, promoDiscount, total } = calculateTotals();

    return {
      ...(orderUserId != null ? { userId: parseInt(orderUserId, 10) } : {}),
      customerName,
      customerEmail,
      customerPhone,
      customerAddress: {
        street,
        city,
        state: cleanStateForShiprocket(state),
        pincode,
        country: "India",
      },
      orderedProducts: cartItems.map((item) => ({
        productId: item.productId,
        productName: item.productName,
        sku: item.sku,
        size: item.size || item.cartSize || item.selectedSize || "",
        quantity: item.quantity,
        unitPrice: item.productPrice,
        totalProductPrice: item.productPrice * item.quantity,
        length: parseFloat(formData.packageLength),
        width: parseFloat(formData.packageWidth),
        height: parseFloat(formData.packageHeight),
        weight: parseFloat(formData.packageWeight),
        hsn: item.hsn || "6204",
        discount:
          item.beforeDiscountPrice > item.productPrice
            ? item.beforeDiscountPrice - item.productPrice
            : 0,
        tax: 0,
      })),
      orderDate: date,
      orderTime: time,
      orderStatus: "PENDING",
      paymentType,
      paymentMethod: isOnlinePayment(paymentType) ? "RAZORPAY" : "COD",
      paymentStatus: "PENDING",
      paymentAttempts: 0,
      subTotal: parseFloat(subtotal),
      shippingPrice: parseFloat(shipping),
      totalPrice: parseFloat(total),
      ...(promoDiscount > 0 && promoCode
        ? {
            promoCode: promoCode,
            promoDiscount: parseFloat(promoDiscount),
          }
        : {}),
      updatedDate: dateTime,
      packageLength: parseFloat(formData.packageLength),
      packageWidth: parseFloat(formData.packageWidth),
      packageHeight: parseFloat(formData.packageHeight),
      packageWeight: parseFloat(formData.packageWeight),
      pickupLocation: formData.pickupLocation,
    };
  };

  const handleRetryPayment = async () => {
    if (!razorpayOrderId) {
      showErrorPopup("No order ID available for retry.");
      return;
    }

    try {
      const orderResponse = await api.get(
        `/orders/razorpay/${razorpayOrderId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (orderResponse.data.paymentAttempts >= 3) {
        showErrorPopup("Maximum payment attempts exceeded.");
        return;
      }

      const keyResponse = await api.get("/razorpay-key");
      const keyId = keyResponse.data;

      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        showErrorPopup("Failed to load payment gateway.");
        return;
      }

      const selectedAddress = addresses.find(
        (addr) => addr.userDetailsId === selectedAddressId
      );

      const options = {
        key: keyId,
        order_id: razorpayOrderId,
        amount: (calculateTotals().total * 100).toString(),
        currency: "INR",
        name: "Aminii Clothing",
        description: "Order Payment",
        config: {
          display: {
            hide: [
              { method: "emi" },
              { method: "paylater" },
            ],
            preferences: { show_default_blocks: true },
          },
        },
        handler: async (response) => {
          const payload = {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            payment_method: paymentType || "unknown",
            created_at: Math.floor(Date.now() / 1000),
          };

          try {
            const verifyResponse = await api.post(
              "/verify-payment",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                payment_method: paymentType || "unknown",
                created_at: Math.floor(Date.now() / 1000),
              },

              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
            showSuccessPopup(
              "Payment successful! Order placed.",
              orderResponse.data.orderId
            );
            await Promise.all(
              cartItems.map((item) => api.delete(`/cart/${item.cartId}`))
            );
            setCartItems([]);
          } catch (err) {
            showErrorPopup(
              "Payment verification failed: " +
                (err.response?.data || err.message),
              true,
              razorpayOrderId
            );
          }
        },
        modal: {
          ondismiss: async () => {
            await api.post(
              "/payment-failed",
              {
                razorpayOrderId: razorpayOrderId,
                razorpayPaymentId: "pay_manual_cancel",
                error_description: "Payment cancelled by user",
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
            showErrorPopup("Payment cancelled by user.", true, razorpayOrderId);
          },
        },
        prefill: {
          name: selectedAddress?.fullName || formData.fullName || "",
          contact: selectedAddress?.phone || formData.phone || "",
          email: selectedAddress?.userEmail || formData.email || localStorage.getItem("userEmail") || localStorage.getItem("email") || "",
        },
        theme: {
          color: "#F37254",
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", async (response) => {
        await api.post(
          "/payment-failed",
          {
            razorpayOrderId: response.error.metadata.order_id,
            razorpayPaymentId: response.error.metadata.payment_id,
            error_description: response.error.description,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        showErrorPopup(
          `Payment failed: ${response.error.description}`,
          true,
          razorpayOrderId
        );
      });
      rzp.open();
    } catch (err) {
      showErrorPopup(
        "Failed to initiate payment retry: " +
          (err.response?.data || err.message)
      );
    }
  };

  const getCurrentDateAndTime = () => {
    const now = new Date();
    const date = `${String(now.getDate()).padStart(2, "0")}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${now.getFullYear()}`;
    const time = `${String(now.getHours()).padStart(2, "0")}:${String(
      now.getMinutes()
    ).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
    return { date, time, dateTime: `${date} ${time}` };
  };

  const handlePlaceOrder = () => {
    if (cartItems.length === 0) {
      showErrorPopup("Your cart is empty.");
      return;
    }

    const guestCheckout = !hasValidSession();

    if (guestCheckout) {
      if (!validateForm()) {
        showErrorPopup("Please fill in all required contact and shipping details.");
        return;
      }
      // Guest validation passed — prompt that address will not be saved for future orders
      setShowGuestAddressModal(true);
      return;
    } else if (!selectedAddressId) {
      showErrorPopup("Please select or add a shipping address.");
      return;
    }

    // Validation passed for logged-in user — open confirmation modal
    setShowConfirmModal(true);
  };

  const executePlaceOrder = async (chosenPaymentType = "ONLINE_PAYMENT", retryCount = 0) => {
    setShowConfirmModal(false);
    setIsPlacingOrder(true);
    setPaymentType(chosenPaymentType);
    const guestCheckout = !hasValidSession();

    try {
      const token = localStorage.getItem("token");
      if (!guestCheckout && token && isTokenExpired(token)) {
        const refreshed = await refreshToken();
        if (!refreshed) {
          clearStaleAuth();
          showErrorPopup(
            "Your session expired. You can still checkout as a guest below."
          );
          setIsPlacingOrder(false);
          return;
        }
      }

      let orderPayload;

      if (guestCheckout) {
        orderPayload = buildOrderPayload({
          customerName: formData.fullName.trim(),
          customerEmail: formData.email.trim(),
          customerPhone: formData.phone.trim(),
          street: buildStreetAddress(formData.address, formData.appartment),
          city: formData.city.trim(),
          state: formData.state,
          pincode: formData.zip.trim(),
          orderUserId: null,
        });

        const orderResponse = await api.post("/orders/guest", orderPayload);
        const order = unwrapApiData(orderResponse);

        if (isOnlinePayment()) {
          try {
            await openRazorpayCheckout({
              order,
              prefill: {
                name: formData.fullName.trim(),
                contact: formData.phone.trim(),
                email: formData.email.trim(),
              },
              onSuccess: () => {
                clearGuestCart();
                setCartItems([]);
                setPlacedOrderId(order?.orderId);
                setOrderSuccess(true);
              },
            });
          } catch (payErr) {
            if (payErr?.message !== "cancelled") {
              showErrorPopup(
                getApiErrorMessage(payErr, "Payment could not be started.")
              );
            }
          }
          setIsPlacingOrder(false);
          return;
        }

        clearGuestCart();
        setCartItems([]);
        setPlacedOrderId(order?.orderId);
        setOrderSuccess(true);
        setIsPlacingOrder(false);
        return;
      }

      const selectedAddress = addresses.find(
        (addr) => addr.userDetailsId === selectedAddressId
      );

      let customerEmail = "";
      try {
        const response = await axios.get(`${API_BASE_URL}/users/${userId}`, {
          withCredentials: true,
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        customerEmail =
          response.data?.data?.userEmail || response.data?.userEmail || "";
      } catch (emailErr) {
        customerEmail = selectedAddress?.userEmail || formData.email || "";
      }

      if (!customerEmail) {
        customerEmail =
          localStorage.getItem("userEmail") ||
          localStorage.getItem("atlas_email") ||
          formData.email ||
          "";
      }

      orderPayload = buildOrderPayload({
        customerName: selectedAddress?.fullName || "",
        customerEmail: customerEmail || formData.email,
        customerPhone: selectedAddress?.phone || "",
        street: buildStreetAddress(
          selectedAddress?.address || "",
          selectedAddress?.appartment
        ),
        city: selectedAddress?.city || "",
        state: selectedAddress?.state || "",
        pincode: selectedAddress?.zip?.toString() || "",
        orderUserId: userId,
      });

      const orderResponse = await api.post("/orders", orderPayload, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const order = unwrapApiData(orderResponse);

      if (isOnlinePayment()) {
        try {
          await openRazorpayCheckout({
            order,
            prefill: {
              name: selectedAddress?.fullName || "",
              contact: selectedAddress?.phone || "",
              email: customerEmail || formData.email || "",
            },
            onSuccess: async () => {
              showSuccessPopup(
                "Payment successful! Order placed.",
                order?.orderId
              );
              await Promise.all(
                cartItems
                  .filter((item) => item.cartId)
                  .map((item) => api.delete(`/cart/${item.cartId}`))
              );
              setCartItems([]);
            },
          });
        } catch (payErr) {
          if (payErr?.message !== "cancelled") {
            showErrorPopup(
              getApiErrorMessage(payErr, "Payment could not be started.")
            );
          }
        }
        setIsPlacingOrder(false);
        return;
      }

      showSuccessPopup(
        "Order placed successfully! Thank you for your purchase.",
        order?.orderId
      );
      await Promise.all(
        cartItems
          .filter((item) => item.cartId)
          .map((item) => api.delete(`/cart/${item.cartId}`))
      );
      setCartItems([]);
    } catch (err) {
      // Better error handling based on status codes
      if (err.response?.status === 400) {
        showErrorPopup(
          "Invalid order data: " +
            (err.response?.data?.message || "Please check your order details")
        );
      } else if (err.response?.status === 401) {
        if (retryCount < 1) {
          const refreshed = await refreshToken();
          if (refreshed) {
            return handlePlaceOrder(retryCount + 1);
          }
        }
        clearStaleAuth();
        showErrorPopup(
          "Session expired. Please try again — guest checkout is still available."
        );
      } else if (err.response?.status === 403) {
        showErrorPopup("Access denied. Please check your permissions.");
      } else {
        showErrorPopup("Failed to place order: " + getApiErrorMessage(err));
      }
    } finally {
      setIsPlacingOrder(false);
    }
  };

  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  };

  const getPrimaryAddress = () => {
    if (addresses.length === 0) return null;
    return (
      addresses.find((addr) => addr.userDetailsId === selectedAddressId) ||
      addresses[0]
    );
  };

  const getOrderButtonText = () => {
    if (isPlacingOrder) return "Processing...";
    const { total } = calculateTotals();
    if (isOnlinePayment()) return `Pay now — ₹${total}`;
    return `Place Order — ₹${total}`;
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const {
    originalSubtotal,
    initialDiscount,
    promoDiscount: promoDiscountValue,
    total,
  } = calculateTotals();

  const guestCheckout = !hasValidSession();

  if (orderSuccess && guestCheckout && placedOrderId) {
    return (
      <div className="checkout-container aminii-checkout-page checkout-confirmation">
        <div className="checkout-confirmation-card">
          <h2>Thank you for your order!</h2>
          <p>Your order <strong>#{placedOrderId}</strong> has been placed successfully.</p>
          <p className="checkout-confirmation-note">
            We will contact you shortly to confirm delivery details.
          </p>
          <button
            className="place-order-button"
            type="button"
            onClick={() => navigate("/productList")}
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="checkout-container aminii-checkout-page">
      <div className="checkout-top-bar">
        <button
          className="checkout-back-btn"
          onClick={() => navigate("/addtocart")}
          type="button"
          aria-label="Back to Cart"
          title="Back to Cart"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="amin-brand-name-checkout" style={{ flex: 1, textAlign: "center", margin: 0, cursor: "pointer" }} onClick={() => navigate("/")}>
          <p className="amin-brand-n">A M I N I I</p>
          <p className="amin-brand-s">C L O T H I N G</p>
        </div>
        <button
          className="checkout-explore-btn"
          onClick={() => navigate("/")}
          type="button"
          aria-label="Explore Products"
          title="Explore Products"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="currentColor"
          >
            <path d="M200-80q-33 0-56.5-23.5T120-160v-480q0-33 23.5-56.5T200-720h80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720h80q33 0 56.5 23.5T840-640v480q0 33-23.5 56.5T760-80H200Zm0-80h560v-480H200v480Zm421.5-298.5Q680-517 680-600h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85h-80q0 83 58.5 141.5T480-400q83 0 141.5-58.5ZM360-720h240q0-50-35-85t-85-35q-50 0-85 35t-35 85ZM200-160v-480 480Z" />
          </svg>
        </button>
      </div>

      <div className="checkout-layout">
        <div className="checkout-left">
      {guestCheckout ? (
        <>
          {/* Section 1: Contact (Email at top & news checkbox) */}
          <div className="checkout-block shopify-checkout-block">
            <div className="shopify-section-header-row">
              <h3 className="shopify-block-title">Contact</h3>
              <button
                type="button"
                className="shopify-signin-btn"
                onClick={() => navigate("/login")}
              >
                Sign in
              </button>
            </div>
            <form className="guest-checkout-form" onSubmit={(e) => e.preventDefault()}>
              <div className="shopify-form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email || ""}
                  onChange={handleInputChange}
                  placeholder="Email"
                  className={`shopify-input ${formErrors.email ? "input-error" : ""}`}
                />
                {formErrors.email && <p className="error-text">{formErrors.email}</p>}
              </div>
              <label className="shopify-checkbox-row">
                <input
                  type="checkbox"
                  name="emailNewsOffers"
                  checked={formData.emailNewsOffers || false}
                  onChange={handleInputChange}
                />
                <span>Email me with news and offers</span>
              </label>
            </form>
          </div>

          {/* Section 2: Delivery */}
          <div className="checkout-block shopify-checkout-block">
            <div className="shopify-section-header-row">
              <h3 className="shopify-block-title">Delivery</h3>
              <button
                type="button"
                className={`location-detect-btn${isDetectingLocation ? " is-detecting" : ""}`}
                onClick={() => handleDetectLocation("shipping")}
                disabled={isDetectingLocation}
                aria-label="Auto-fill shipping address from current location"
              >
                <span className="loc-icon">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" fill="currentColor"/>
                  </svg>
                </span>
                <span className="loc-label">{isDetectingLocation ? "Detecting..." : "Use Current Location"}</span>
              </button>
            </div>
            <form className="guest-checkout-form" onSubmit={(e) => e.preventDefault()}>
              {/* Country/Region */}
              <div className="shopify-form-group">
                <div className="shopify-country-wrap">
                  <span className="shopify-country-label">Country/Region</span>
                  <div className="shopify-country-select-row">
                    <select
                      name="country"
                      value={formData.country || "India"}
                      onChange={handleInputChange}
                      className="shopify-country-select"
                    >
                      <option value="India">India</option>
                    </select>
                    <svg className="shopify-select-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>
                </div>
              </div>

              {/* First Name & Last Name (2 cols desktop, stacked mobile) */}
              <div className="shopify-name-row">
                <div className="shopify-form-group">
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName || ""}
                    onChange={handleInputChange}
                    placeholder="First name"
                    className={`shopify-input ${formErrors.firstName ? "input-error" : ""}`}
                  />
                  {formErrors.firstName && <p className="error-text">{formErrors.firstName}</p>}
                </div>
                <div className="shopify-form-group">
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName || ""}
                    onChange={handleInputChange}
                    placeholder="Last name"
                    className="shopify-input"
                  />
                </div>
              </div>

              {/* Address with search/location icon */}
              <div className="shopify-form-group">
                <div className="shopify-input-with-icon">
                  <input
                    type="text"
                    name="address"
                    value={formData.address || ""}
                    onChange={handleInputChange}
                    placeholder="Address"
                    className={`shopify-input ${formErrors.address ? "input-error" : ""}`}
                  />
                  <button
                    type="button"
                    className="shopify-input-icon-btn"
                    onClick={() => handleDetectLocation("shipping")}
                    title="Detect address location"
                    aria-label="Detect address location"
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8" />
                      <line x1="21" y1="21" x2="16.65" y2="16.65" />
                    </svg>
                  </button>
                </div>
                {formErrors.address && <p className="error-text">{formErrors.address}</p>}
              </div>

              {/* Apartment, suite, etc. */}
              <div className="shopify-form-group">
                <input
                  type="text"
                  name="appartment"
                  value={formData.appartment || ""}
                  onChange={handleInputChange}
                  placeholder="Apartment, suite, etc. (optional)"
                  className="shopify-input"
                />
              </div>

              {/* City, State, PIN code (3 cols desktop, stacked mobile) */}
              <div className="shopify-city-state-pin-row">
                <div className="shopify-form-group">
                  <input
                    type="text"
                    name="city"
                    value={formData.city || ""}
                    onChange={handleInputChange}
                    placeholder="City"
                    className={`shopify-input ${formErrors.city ? "input-error" : ""}`}
                  />
                  {formErrors.city && <p className="error-text">{formErrors.city}</p>}
                </div>
                <div className="shopify-form-group">
                  <StateDropdown
                    name="state"
                    value={formData.state}
                    onChange={(e) => {
                      setFormData((prev) => ({ ...prev, state: e.target.value }));
                      if (formErrors.state) setFormErrors((prev) => ({ ...prev, state: "" }));
                    }}
                    hasError={!!formErrors.state}
                    placeholder="State"
                  />
                  {formErrors.state && <p className="error-text">{formErrors.state}</p>}
                </div>
                <div className="shopify-form-group">
                  <input
                    type="text"
                    name="zip"
                    value={formData.zip || ""}
                    onChange={handleInputChange}
                    placeholder="PIN code"
                    className={`shopify-input ${formErrors.zip ? "input-error" : ""}`}
                  />
                  {formErrors.zip && <p className="error-text">{formErrors.zip}</p>}
                </div>
              </div>

              {/* Phone */}
              <div className="shopify-form-group">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone || ""}
                  onChange={handleInputChange}
                  placeholder="Phone"
                  className={`shopify-input ${formErrors.phone ? "input-error" : ""}`}
                />
                {formErrors.phone && <p className="error-text">{formErrors.phone}</p>}
              </div>

              {/* Save info checkbox */}
              <label className="shopify-checkbox-row">
                <input
                  type="checkbox"
                  checked={saveContactInfo}
                  onChange={(e) => setSaveContactInfo(e.target.checked)}
                />
                <span>Save this information for next time</span>
              </label>
            </form>
          </div>

          {renderShippingMethod()}
          {renderPaymentAndBilling()}
          {renderPayNowButton()}
        </>
      ) : (
        <>
          {/* If user already has a saved address and is NOT currently adding/editing */}
          {addresses.length > 0 && !showForm && (
            <div className="checkout-block shopify-checkout-block">
              <div className="shopify-section-header-row">
                <h3 className="shopify-block-title">Delivery</h3>
                <button
                  type="button"
                  className="shopify-new-address-link"
                  onClick={handleAddNewAddress}
                >
                  + Add New Address
                </button>
              </div>

              {getPrimaryAddress() && (
                <div className="shopify-saved-address-card">
                  <div className="shopify-saved-address-info">
                    <p className="shopify-saved-name">{getPrimaryAddress().fullName}</p>
                    <p className="shopify-saved-street">
                      {getPrimaryAddress().address}
                      {getPrimaryAddress().appartment ? `, ${getPrimaryAddress().appartment}` : ""}
                    </p>
                    <p className="shopify-saved-city">
                      {getPrimaryAddress().city}, {getPrimaryAddress().state || getPrimaryAddress().State} - {getPrimaryAddress().zip}
                    </p>
                    <p className="shopify-saved-phone">{getPrimaryAddress().phone}</p>
                  </div>
                  <div className="shopify-saved-actions">
                    <button
                      type="button"
                      className="shopify-edit-link"
                      onClick={(e) => handleEditAddress(getPrimaryAddress(), e)}
                    >
                      Edit
                    </button>
                    {addresses.length > 1 && (
                      <button
                        type="button"
                        className="shopify-change-link"
                        onClick={() => setIsAddressDropdownOpen(!isAddressDropdownOpen)}
                      >
                        {isAddressDropdownOpen ? "Hide list" : `Change (${addresses.length} saved)`}
                      </button>
                    )}
                  </div>
                </div>
              )}

              {addresses.length > 1 && isAddressDropdownOpen && (
                <div className="address-dropdown open" style={{ marginTop: "12px" }}>
                  {addresses.map((address) => (
                    <div
                      key={address.userDetailsId}
                      className={`address-card ${selectedAddressId === address.userDetailsId ? "selected" : ""}`}
                      onClick={() => handleCardClick(address.userDetailsId)}
                    >
                      <div className="address-details">
                        <p className="address-name">{address.fullName} • {address.phone}</p>
                        <p className="address-text">
                          {address.address}{address.appartment ? `, ${address.appartment}` : ""}, {address.city}, {address.state || address.State} - {address.zip}
                        </p>
                      </div>
                      <div className="address-actions" onClick={(e) => e.stopPropagation()}>
                        <button className="edit-button" onClick={(e) => handleEditAddress(address, e)}>
                          Edit
                        </button>
                        <button className="remove-button" onClick={(e) => handleDeleteAddress(address.userDetailsId, e)}>
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* If user clicked "Add New Address", "Edit", or has no saved addresses */}
          {(showForm || addresses.length === 0) && (
            <div ref={formRef}>
              {/* Section 1: Contact (Email at top) */}
              <div className="checkout-block shopify-checkout-block">
                <div className="shopify-section-header-row">
                  <h3 className="shopify-block-title">Contact</h3>
                  <button
                    type="button"
                    className="shopify-signin-btn"
                    onClick={() => navigate("/login")}
                  >
                    Sign in
                  </button>
                </div>
                <div className="shopify-form-group">
                  <input
                    type="email"
                    name="email"
                    value={formData.email || ""}
                    onChange={handleInputChange}
                    placeholder="Email"
                    className={`shopify-input ${formErrors.email ? "input-error" : ""}`}
                  />
                  {formErrors.email && <p className="error-text">{formErrors.email}</p>}
                </div>
                <label className="shopify-checkbox-row">
                  <input
                    type="checkbox"
                    name="emailNewsOffers"
                    checked={formData.emailNewsOffers || false}
                    onChange={handleInputChange}
                  />
                  <span>Email me with news and offers</span>
                </label>
              </div>

              {/* Section 2: Delivery */}
              <div className="checkout-block shopify-checkout-block">
                <div className="shopify-section-header-row">
                  <h3 className="shopify-block-title">
                    {editAddressId ? "Edit Delivery Address" : "Delivery"}
                  </h3>
                  <button
                    type="button"
                    className={`location-detect-btn${isDetectingLocation ? " is-detecting" : ""}`}
                    onClick={() => handleDetectLocation("shipping")}
                    disabled={isDetectingLocation}
                    aria-label="Auto-fill shipping address from current location"
                  >
                    <span className="loc-icon">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" fill="currentColor"/>
                      </svg>
                    </span>
                    <span className="loc-label">{isDetectingLocation ? "Detecting..." : "Use Current Location"}</span>
                  </button>
                </div>
                <form onSubmit={handleSubmit}>
                  {/* Country/Region */}
                  <div className="shopify-form-group">
                    <div className="shopify-country-wrap">
                      <span className="shopify-country-label">Country/Region</span>
                      <div className="shopify-country-select-row">
                        <select
                          name="country"
                          value={formData.country || "India"}
                          onChange={handleInputChange}
                          className="shopify-country-select"
                        >
                          <option value="India">India</option>
                        </select>
                        <svg className="shopify-select-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* First name & Last name */}
                  <div className="shopify-name-row">
                    <div className="shopify-form-group">
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName || ""}
                        onChange={handleInputChange}
                        placeholder="First name"
                        className={`shopify-input ${formErrors.firstName ? "input-error" : ""}`}
                      />
                      {formErrors.firstName && <p className="error-text">{formErrors.firstName}</p>}
                    </div>
                    <div className="shopify-form-group">
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName || ""}
                        onChange={handleInputChange}
                        placeholder="Last name"
                        className="shopify-input"
                      />
                    </div>
                  </div>

                  {/* Address */}
                  <div className="shopify-form-group">
                    <div className="shopify-input-with-icon">
                      <input
                        type="text"
                        name="address"
                        value={formData.address || ""}
                        onChange={handleInputChange}
                        placeholder="Address"
                        className={`shopify-input ${formErrors.address ? "input-error" : ""}`}
                      />
                      <button
                        type="button"
                        className="shopify-input-icon-btn"
                        onClick={() => handleDetectLocation("shipping")}
                        title="Detect address location"
                        aria-label="Detect address location"
                      >
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="11" cy="11" r="8" />
                          <line x1="21" y1="21" x2="16.65" y2="16.65" />
                        </svg>
                      </button>
                    </div>
                    {formErrors.address && <p className="error-text">{formErrors.address}</p>}
                  </div>

                  {/* Apartment, suite, etc. */}
                  <div className="shopify-form-group">
                    <input
                      type="text"
                      name="appartment"
                      value={formData.appartment || ""}
                      onChange={handleInputChange}
                      placeholder="Apartment, suite, etc. (optional)"
                      className="shopify-input"
                    />
                  </div>

                  {/* City, State, PIN code */}
                  <div className="shopify-city-state-pin-row">
                    <div className="shopify-form-group">
                      <input
                        type="text"
                        name="city"
                        value={formData.city || ""}
                        onChange={handleInputChange}
                        placeholder="City"
                        className={`shopify-input ${formErrors.city ? "input-error" : ""}`}
                      />
                      {formErrors.city && <p className="error-text">{formErrors.city}</p>}
                    </div>
                    <div className="shopify-form-group">
                      <StateDropdown
                        name="state"
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((prev) => ({ ...prev, state: e.target.value }));
                          if (formErrors.state) setFormErrors((prev) => ({ ...prev, state: "" }));
                        }}
                        hasError={!!formErrors.state}
                        placeholder="State"
                      />
                      {formErrors.state && <p className="error-text">{formErrors.state}</p>}
                    </div>
                    <div className="shopify-form-group">
                      <input
                        type="text"
                        name="zip"
                        value={formData.zip || ""}
                        onChange={handleInputChange}
                        placeholder="PIN code"
                        className={`shopify-input ${formErrors.zip ? "input-error" : ""}`}
                      />
                      {formErrors.zip && <p className="error-text">{formErrors.zip}</p>}
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="shopify-form-group">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone || ""}
                      onChange={handleInputChange}
                      placeholder="Phone"
                      className={`shopify-input ${formErrors.phone ? "input-error" : ""}`}
                    />
                    {formErrors.phone && <p className="error-text">{formErrors.phone}</p>}
                  </div>

                  {/* Save info checkbox */}
                  <label className="shopify-checkbox-row">
                    <input
                      type="checkbox"
                      checked={saveContactInfo}
                      onChange={(e) => setSaveContactInfo(e.target.checked)}
                    />
                    <span>Save this information for next time</span>
                  </label>

                  {/* Action buttons */}
                  <div className="shopify-form-actions">
                    <button
                      type="submit"
                      className="shopify-save-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : editAddressId ? "Update Address" : "Save Address"}
                    </button>
                    {addresses.length > 0 && (
                      <button
                        type="button"
                        className="shopify-cancel-btn"
                        onClick={() => setShowForm(false)}
                      >
                        Cancel
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          )}

          {renderShippingMethod()}
          {renderPaymentAndBilling()}
          {renderPayNowButton()}
        </>
      )}
        </div>

        <aside className="checkout-right">
          <div className="checkout-order-summary-panel">
            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>{error}</p>
            ) : cartItems.length === 0 ? (
              <p>Your cart is empty</p>
            ) : (
              <div className="checkout-line-items">
                {cartItems.map((item) => (
                  <div
                    key={item.cartId ?? `${item.productId}-${item.size}`}
                    className="checkout-line-item"
                  >
                    <div className="checkout-line-image-wrap">
                      <img
                        src={item.productImage}
                        alt={item.productName}
                        onError={handleImageError}
                      />
                      <span className="checkout-qty-badge">{item.quantity}</span>
                    </div>
                    <div className="checkout-line-details">
                      <p className="checkout-line-name">{item.productName}</p>
                      <p className="checkout-line-meta">Size {item.size}</p>
                    </div>
                    <p className="checkout-line-price-right">
                      ₹{(item.productPrice * item.quantity).toFixed(2)}
                    </p>
                  </div>
                ))}
              </div>
            )}

            {promoCode && (
              <div className="checkout-discount-applied">
                Discount applied: {promoCode}
              </div>
            )}
            {!promoCode && (
              <div className="checkout-discount-row">
                <input
                  type="text"
                  placeholder="Discount code"
                  className="checkout-discount-input"
                  readOnly
                  aria-label="Discount code"
                />
                <button type="button" className="checkout-discount-apply" disabled>
                  Apply
                </button>
              </div>
            )}

            <div className="checkout-summary">
              <div className="checkout-row">
                <span>Subtotal</span>
                <span>₹{parseFloat(originalSubtotal).toFixed(2)}</span>
              </div>
              {(parseFloat(initialDiscount) + promoDiscountValue) > 0 && (
                <div className="checkout-row">
                  <span>Discount</span>
                  <span className="price-disc">
                    -₹{(parseFloat(initialDiscount) + promoDiscountValue).toFixed(2)}
                  </span>
                </div>
              )}
              <div className="checkout-row">
                <span>Shipping</span>
                <span className="checkout-shipping-label">
                  {paymentType === "COD" ? (
                    "₹150.00 (COD Charge)"
                  ) : hasShippingDetails() ? (
                    "Free"
                  ) : (
                    "Enter shipping address"
                  )}
                </span>
              </div>
              <div className="checkout-row checkout-total-row">
                <span className="checkout-total-label">Total</span>
                <span className="checkout-total-amount">
                  <span className="checkout-currency">INR</span> ₹{parseFloat(total).toFixed(2)}
                </span>
              </div>
              {/* <p className="checkout-tax-note">
                Including ₹{((parseFloat(total) * 18) / 118).toFixed(2)} in taxes
              </p> */}
            </div>
          </div>
        </aside>
      </div>

      {/* Guest Address Notice Modal */}
      {showGuestAddressModal && (
        <div className="checkout-confirm-overlay" onClick={() => setShowGuestAddressModal(false)}>
          <div className="checkout-confirm-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "460px" }}>
            <div className="confirm-modal-header" style={{ alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                {/* <span style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  backgroundColor: "#fef3c7",
                  color: "#d97706",
                  fontSize: "16px",
                  fontWeight: "bold",
                  flexShrink: 0
                }}>
                  ℹ️ 
                </span> */}
                <h3 style={{ fontSize: "18px", margin: 0 }}> Guest Checkout</h3>
              </div>
              <button
                className="confirm-modal-close"
                onClick={() => setShowGuestAddressModal(false)}
                aria-label="Close"
              >
                ✕
              </button>
            </div>

            <div className="confirm-modal-body" style={{ padding: "20px 24px" }}>
              <div style={{
                backgroundColor: "#fffbeb",
                border: "1px solid #fde68a",
                borderRadius: "8px",
                padding: "14px 16px",
                marginBottom: "18px",
                color: "#92400e",
                fontSize: "14px",
                lineHeight: "1.5"
              }}>
                <p style={{ margin: "0 0 6px 0", fontWeight: "700", color: "#b45309" }}>
                  Address will not be saved for future orders
                </p>
                {/* <p style={{ margin: 0, fontSize: "13px", color: "#78350f" }}>
                  You are checking out as a guest. This delivery address will <strong>not be saved</strong> in your account. You will have to re-enter your address again for future orders.
                </p> */}
              </div>

              <p style={{ fontSize: "13.5px", color: "#4b5563", lineHeight: "1.5", marginBottom: "20px" }}>
                Want faster 1-click checkout next time? <strong>Log in</strong> or <strong>Sign up</strong> to automatically save your delivery address, track orders, and view order history.
              </p>

              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => {
                      setShowGuestAddressModal(false);
                      navigate("/register");
                    }}
                    style={{
                      padding: "11px 16px",
                      backgroundColor: "#1a1a1a",
                      color: "#ffffff",
                      border: "none",
                      borderRadius: "6px",
                      fontWeight: "600",
                      fontSize: "13.5px",
                      cursor: "pointer",
                      transition: "background 0.2s",
                    }}
                  >
                    Sign up & Save
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      setShowGuestAddressModal(false);
                      navigate("/login");
                    }}
                    style={{
                      padding: "11px 16px",
                      backgroundColor: "#ffffff",
                      color: "#1a1a1a",
                      border: "1.5px solid #1a1a1a",
                      borderRadius: "6px",
                      fontWeight: "600",
                      fontSize: "13.5px",
                      cursor: "pointer",
                      transition: "background 0.2s",
                    }}
                  >
                    Log in
                  </button>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    setShowGuestAddressModal(false);
                    setShowConfirmModal(true);
                  }}
                  style={{
                    padding: "11px 16px",
                    backgroundColor: "transparent",
                    color: "#4b5563",
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    fontWeight: "500",
                    fontSize: "13px",
                    cursor: "pointer",
                    marginTop: "4px",
                    transition: "all 0.2s",
                  }}
                >
                  Continue without saving
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Two-Tier Payment Confirmation Modal */}
      {showConfirmModal && (
        <div className="checkout-confirm-overlay" onClick={() => setShowConfirmModal(false)}>
          <div className="checkout-confirm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="confirm-modal-header">
              <h3>Confirm Your Order</h3>
              <button
                className="confirm-modal-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Close"
                style={{
                  background: "transparent",
                  backgroundColor: "transparent",
                  border: "none",
                  boxShadow: "none",
                  outline: "none",
                  color: "#1a1a1a",
                  fontSize: "20px",
                  fontWeight: "400",
                  cursor: "pointer",
                  padding: "4px 8px",
                  width: "auto",
                  height: "auto",
                  minWidth: "auto",
                  minHeight: "auto",
                  lineHeight: "1",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ✕
              </button>
            </div>

            <div className="confirm-modal-body">
              <div className="confirm-total-summary">
                <div className="confirm-sub-row">
                  <span>Subtotal</span>
                  <span>₹{parseFloat(total).toFixed(2)}</span>
                </div>

                <div className="confirm-cod-row">
                  <div className="confirm-cod-left">
                    <span className="confirm-total-label">Total Amount: ₹{(paymentType === "COD" ? parseFloat(total) : parseFloat(total) + 150).toFixed(2)}</span>
                  </div>
                  <span className="cod-badge">Incl. ₹150.00 COD charges</span>
                </div>
              </div>

              <div className="confirm-action-buttons">
                <button
                  type="button"
                  className={`btn-confirm-cod ${codAvailable === false ? "btn-disabled" : ""}`}
                  onClick={() => {
                    if (codAvailable === false) {
                      showErrorPopup("COD is not available for your delivery pincode. Please pay online.");
                      return;
                    }
                    executePlaceOrder("COD");
                  }}
                  disabled={isPlacingOrder || codAvailable === false}
                  title={codAvailable === false ? "COD is unavailable for your pincode" : ""}
                >
                  {codAvailable === false ? "COD Unavailable for PIN" : "Confirm & place order (COD)"}
                </button>
                <button
                  type="button"
                  className="btn-confirm-online"
                  onClick={() => executePlaceOrder("ONLINE_PAYMENT")}
                  disabled={isPlacingOrder}
                >
                  Pay online (save upto ₹150.00)
                </button>
              </div>
              {codAvailable === false && (
                <p className="cod-unavailable-modal-note">
                  COD is not available for your delivery PIN code. Please proceed with Online Payment.
                </p>
              )}

              <div className="confirm-policy-notes">
                <p> 100% Secure Checkout | Instant Order Confirmation</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="error-popup">
          <div className="error-popup-content">
            <p
              className={
                popupType === "success" ? "success-message" : "error-message"
              }
            >
              {popupMessage}
            </p>
            {popupType === "error" && (
              <div>
                {razorpayOrderId && (
                  <button onClick={handleRetryPayment}>Retry Payment</button>
                )}
                {isLoggedIn && (
                  <button onClick={() => navigate("/orders")}>View Orders</button>
                )}
                <button onClick={closePopup}>Close</button>
              </div>
            )}
            {popupType === "success" && (
              <button onClick={closePopup}>Close</button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
